// AUTO-GENERATED at build time by scripts/generate-prerender-data.mjs.
// Do NOT edit by hand and do NOT commit - this file is gitignored.
// It mirrors the live API so pre-render snapshots match the hydrated site.
export const fallbackProducts = [
  {
    "noindex": false,
    "_id": "69ef61a143bd1776f3fdca82",
    "name": "AW01 Full Cassette Awning",
    "slug": "aw01-full-box-awning",
    "category": "awning",
    "sort_order": 1,
    "in_stock": false,
    "price_from": 1000,
    "pre_discount_price": 1400,
    "short_description": "Motorised full cassette awning. EN 13561 Class 3 wind rating, UPF 60+ Sauleda fabric in 37 colourways, integrated LED, wind sensor free. Up to 7 x 3.5 m.",
    "description": "The AW01 is our flagship full cassette retractable awning. When retracted, the entire fabric and folding arms tuck inside a sealed aluminium cassette - protecting them from sun, dust, and Melbourne weather, and keeping the system looking new for years. It is wind tested by Intertek to EN 13561 Class 3, the highest of the four classes in that standard, where most retractable awnings on the market carry Class 1 or Class 2. The fabric is Spanish Sauleda acrylic: rated UPF 60+ against UVB under UV STANDARD 801 and blocking 99% of UVA rays. UV STANDARD 801 is the strictest UV test for shade textiles because it measures the fabric wet, stretched, abraded and aged rather than only new and dry, so the rating still means something in year five. The same fabric is certified to STANDARD 100 by OEKO-TEX for substances harmful to health and skin, and is woven, dyed and finished in Sauleda’s ISO 9001 certified plant in Barcelona - ISO 9001 held since 1999. Operate by remote, app, or wall switch (electric) or by hand crank (manual) - both options ship standard. A wireless wind and sun sensor is included free, valued at $150: it mounts on the wall beside the awning and retracts it automatically when the wind rises above the speed you set, whether you are home or not. LED strips along the cassette and each arm are built in and turn the system into a full evening lighting feature. Maximum coverage from a single set is 7 m wide × 3.5 m projection. Available in 5 curated default colours - Classic Mid Grey, Soft Off-White, Warm Sand Beige, Deep Espresso Brown, and Monument Charcoal - chosen to suit the most common Australian home palettes. The full Sauleda range covers 19 solid colours plus 18 striped patterns, all at the same price. Built to last 10 years or more; our 3-year warranty covers the whole awning, fabric included, from the date of delivery. Free delivery to local Melbournians.",
    "images": [
      "/uploads/products/aw01-g-01-hero-extended.webp",
      "/uploads/products/aw01-g-03-evening-led.webp",
      "/uploads/products/aw01-g-02-retracted-closed.webp",
      "/uploads/products/awning-remote.webp",
      "/uploads/products/aw01-g-05-cassette-endcap.webp",
      "/uploads/products/aw01-g-06-arm-joint.webp",
      "/uploads/products/aw01-g-07-fabric-texture.webp",
      "/images/products/awnings/awning-aw01-classical-stock-v5.webp",
      "/uploads/products/aw01-g-10-cafe-frontage.webp",
      "/uploads/products/aw01-g-09-family-dining.webp",
      "/uploads/products/aw01-clean.webp",
      "/uploads/products/aw01-restaurant-people.webp"
    ],
    "specs": [
      "From $1,000 - free local Melbourne delivery",
      "Maximum single set: 7 m × 3.5 m (width × projection)",
      "Wind tested by Intertek to EN 13561 Class 3 - the highest class in the standard",
      "UPF 60+ against UVB, certified to UV STANDARD 801",
      "Blocks 99% of UVA rays",
      "STANDARD 100 by OEKO-TEX certified - no substances harmful to health or skin",
      "Sauleda fabric made in an ISO 9001 plant in Barcelona, Made in Europe",
      "Spanish Sauleda fabric: 19 solid colours + 18 striped patterns, all one price",
      "Operation: electric (remote / app / wall switch) + manual hand crank",
      "Wind and sun sensor included free - valued at $150",
      "Integrated LED lighting along the cassette and each arm (standard)",
      "Acrylic fabric with a self-cleaning, water-shedding finish",
      "Cassette: fully enclosed aluminium full cassette",
      "Mounting: wall-mounted (most common) or roof-mounted",
      "Expected service life 10+ years",
      "3-year warranty on the whole awning, fabric included; built to last 10+ years"
    ],
    "dimensions": [
      {
        "spec": "Width range",
        "value": "2.0 m to 7.0 m",
        "_id": "69fc783cbda957f4eee3c89c"
      },
      {
        "spec": "Projection range",
        "value": "1.5 m to 3.5 m",
        "_id": "69fc783cbda957f4eee3c89d"
      },
      {
        "spec": "Maximum single set (W × P)",
        "value": "7.0 m × 3.5 m",
        "_id": "69fc783cbda957f4eee3c89e"
      },
      {
        "spec": "Minimum single set (W × P)",
        "value": "2.0 m × 1.5 m",
        "_id": "69fc783cbda957f4eee3c89f"
      },
      {
        "spec": "Folding arm, front section",
        "value": "60.7 mm wide x 32 mm high, 2.2 mm wall",
        "_id": "69fc783cbda957f4eee3c8a0"
      },
      {
        "spec": "Folding arm, rear section",
        "value": "68.1 mm wide x 38 mm high, 2.2 mm wall",
        "_id": "69fc783cbda957f4eee3c8a1"
      },
      {
        "spec": "Cassette, closed",
        "value": "236.5 mm deep x 146 mm high",
        "_id": "69fc783cbda957f4eee3c8a2"
      },
      {
        "spec": "Cassette enclosure",
        "value": "Full cassette, fully enclosed",
        "_id": "69fc783cbda957f4eee3c8a3"
      },
      {
        "spec": "Drainage",
        "value": "Hidden system",
        "_id": "69fc783cbda957f4eee3c8a4"
      },
      {
        "spec": "Arm mechanism",
        "value": "Thickened stainless steel chain link",
        "_id": "69fc783cbda957f4eee3c8a5"
      },
      {
        "spec": "LED",
        "value": "Integrated waterproof LED strips",
        "_id": "69fc783cbda957f4eee3c8a6"
      },
      {
        "spec": "Fabric",
        "value": "Spanish Sauleda (3-year warranty, 10+ years expected life)",
        "_id": "69fc783cbda957f4eee3c8a7"
      },
      {
        "spec": "Operation",
        "value": "Motorised + wireless remote (manual hand crank backup)",
        "_id": "69fc783cbda957f4eee3c8a8"
      },
      {
        "spec": "Mounting",
        "value": "Wall (standard) or ceiling",
        "_id": "69fc783cbda957f4eee3c8a9"
      },
      {
        "_id": "6adf30faded02686728e053d",
        "spec": "UV protection",
        "value": "UPF 60 to UPF 80 against UVB; blocks 99% of UVA"
      },
      {
        "_id": "6adf30faded02686728e053e",
        "spec": "UV certification",
        "value": "UV STANDARD 801 - measured wet, stretched, abraded and aged"
      },
      {
        "_id": "6adf30faded02686728e053f",
        "spec": "Safety certification",
        "value": "STANDARD 100 by OEKO-TEX"
      },
      {
        "_id": "6adf30faded02686728e0540",
        "spec": "Quality certification",
        "value": "ISO 9001, held by Sauleda since 1999"
      },
      {
        "_id": "6adf30faded02686728e0541",
        "spec": "Fabric origin",
        "value": "Woven, dyed and finished in Barcelona. Made in Europe"
      }
    ],
    "video_mp4": "/uploads/content/aw01-demo-full.mp4",
    "video_webm": "/uploads/content/aw01-demo-full.webm",
    "video_poster": "/uploads/content/aw01-demo-full-poster.webp",
    "variant_prices": [
      {
        "width": 2,
        "projection": 1,
        "price": 1525,
        "pre_discount_price": null
      },
      {
        "width": 3,
        "projection": 2,
        "price": 1850,
        "pre_discount_price": null
      },
      {
        "width": 4,
        "projection": 3,
        "price": 2330,
        "pre_discount_price": null
      },
      {
        "width": 5,
        "projection": 3.5,
        "price": 2905,
        "pre_discount_price": null
      },
      {
        "width": 6,
        "projection": 3.5,
        "price": 3305,
        "pre_discount_price": null
      },
      {
        "width": 7,
        "projection": 3.5,
        "price": 3950,
        "pre_discount_price": null
      }
    ],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "69fb357063740f19a0cfd859",
    "name": "B06 Premium Open-Arm Awning",
    "slug": "b06-premium-open-arm-awning",
    "category": "awning",
    "sort_order": 2,
    "in_stock": false,
    "price_from": 1000,
    "pre_discount_price": null,
    "short_description": "Premium open-arm retractable awning with integrated waterproof LED light strips in the arms and stainless steel chain link joints. Clean modern lines, no valance, up to 6 m × 3 m. Motorised operation standard. Free delivery to most of Melbourne.",
    "description": "The B06 brings cassette-tier features to an open-arm awning. Integrated waterproof LED strips run inside the curved aluminium arms for a clean architectural lighting effect at night, and stainless steel chain link joints give the arms greater elasticity and long-term durability. A newly upgraded pipe component creates a more secure connection at the rear arm link, and the clean front bar (no valance) suits modern facades. Maximum coverage from a single set is 6 m wide × 3 m projection. Motorised operation standard with wireless remote. Free delivery to local Melbournians, and backed by a 3-year warranty on the whole awning, fabric included.",
    "images": [
      "/uploads/products/image-b06-thumbnail.webp",
      "/uploads/products/b06-clean-upfront-image.webp",
      "/uploads/products/b06-night-over-table-family.webp",
      "/uploads/products/b06-double-awning-over-dining-table-peropl.webp",
      "/uploads/products/awning-remote.webp"
    ],
    "specs": [
      "From $1,000 - free local Melbourne delivery",
      "Maximum single set: 6 m × 3 m (width × projection)",
      "Operation: motorised with wireless remote (standard)",
      "Integrated waterproof LED light strips in the arms",
      "Stainless steel chain link joints (premium durability)",
      "Upgraded rear pipe component for a more secure arm link",
      "Aluminium curved arms (forearm 55.44 mm / rear 64.69 mm",
      "2.27 mm wall)",
      "Clean front bar - no valance",
      "10-component arm set (most feature-rich open-arm model)",
      "Mounting: wall-mounted (most common) or roof-mounted",
      "Spanish Sauleda fabric: 19 solids + 18 stripes (10+ years expected life)",
      "Compatible with our DC8811 wind and sun sensor",
      "3-year warranty on the whole awning, fabric included"
    ],
    "dimensions": [
      {
        "spec": "Width range",
        "value": "2.0 m to 6.0 m",
        "_id": "69fc783c2bf7668b2547e2fa"
      },
      {
        "spec": "Projection range",
        "value": "1.5 m to 3 m",
        "_id": "69fc783c2bf7668b2547e2fb"
      },
      {
        "spec": "Maximum single set (W × P)",
        "value": "6.0 m × 3 m",
        "_id": "69fc783c2bf7668b2547e2fc"
      },
      {
        "spec": "Minimum single set (W × P)",
        "value": "2.0 m × 1.5 m",
        "_id": "69fc783c2bf7668b2547e2fd"
      },
      {
        "spec": "Forearm width",
        "value": "55.44 mm",
        "_id": "69fc783c2bf7668b2547e2fe"
      },
      {
        "spec": "Rear arm width",
        "value": "64.69 mm",
        "_id": "69fc783c2bf7668b2547e2ff"
      },
      {
        "spec": "Profile thickness",
        "value": "2.27 mm",
        "_id": "69fc783c2bf7668b2547e300"
      },
      {
        "spec": "Cassette enclosure",
        "value": "No - clean front bar, no valance",
        "_id": "69fc783c2bf7668b2547e301"
      },
      {
        "spec": "Arm mechanism",
        "value": "Stainless steel chain link, upgraded rear pipe",
        "_id": "69fc783c2bf7668b2547e302"
      },
      {
        "spec": "LED",
        "value": "Integrated waterproof LED strips in arms",
        "_id": "69fc783c2bf7668b2547e303"
      },
      {
        "spec": "Component count",
        "value": "10-part arm set",
        "_id": "69fc783c2bf7668b2547e304"
      },
      {
        "spec": "Operation",
        "value": "Motorised + wireless remote",
        "_id": "69fc783c2bf7668b2547e305"
      },
      {
        "spec": "Mounting",
        "value": "Wall (standard) or ceiling",
        "_id": "69fc783c2bf7668b2547e306"
      }
    ],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [
      {
        "width": 2,
        "projection": 1,
        "price": 790,
        "pre_discount_price": null
      },
      {
        "width": 2.5,
        "projection": 2,
        "price": 899,
        "pre_discount_price": null
      },
      {
        "width": 3,
        "projection": 2,
        "price": 1099,
        "pre_discount_price": null
      },
      {
        "width": 4,
        "projection": 3,
        "price": 1499,
        "pre_discount_price": null
      },
      {
        "width": 5,
        "projection": 3,
        "price": 1899,
        "pre_discount_price": null
      },
      {
        "width": 6,
        "projection": 3,
        "price": 2399,
        "pre_discount_price": null
      }
    ],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "69fb357063740f19a0cfd862",
    "name": "A09 Long-Projection Awning",
    "slug": "a09-long-projection-awning",
    "category": "awning",
    "sort_order": 3,
    "in_stock": false,
    "price_from": 1000,
    "pre_discount_price": null,
    "short_description": "Long-projection retractable awning engineered for deep alfresco areas and exposed sites. Reinforced heavy-gauge 82 mm arms, double plate bracket mounting, straight valance with corner cutouts. Up to 6 m × 4 m - the deepest projection in the range. Free delivery to most of Melbourne.",
    "description": "The A09 is the technical specialist of the range - built for deep alfresco areas, exposed sites, and customers who need the maximum reach a folding-arm awning can deliver. Aluminium arms are thickened and widened (82.13 mm wide, 42.21 mm thick - the largest in the range) for rigidity across deep projections. The double plate bracket mounting spreads load and stiffens the system at the wall. Stainless steel chain interlinks at the joints stay flexible under repeated use without wearing loose. Maximum coverage from a single set is 6 m wide × 4 m projection - deeper than any other awning in the range. Straight valance with corner cutouts at each arm attachment keeps the front bar clean while preserving traditional detailing. Manual operation. Available in the full Spanish Sauleda fabric range - 19 solid colours plus 18 striped patterns. Free delivery to local Melbournians, and a 3-year warranty on the whole awning, fabric included.",
    "images": [
      "/images/products/awnings/awning-a09-stock-v3.webp",
      "/uploads/products/a09-clean.webp",
      "/uploads/products/a09-family.webp",
      "/uploads/products/a09-restaurant.webp"
    ],
    "specs": [
      "From $1,000 - free local Melbourne delivery",
      "Maximum single set: 6 m × 4 m (deepest projection in the range)",
      "Operation: manual",
      "Reinforced heavy-gauge aluminium arms (82.13 mm × 42.21 mm)",
      "Double plate bracket mounting for load-spreading",
      "Stainless steel chain interlink joints",
      "Straight valance with corner cutouts at arm attachments",
      "Profile thickness: 3.27 mm (thickest in the range)",
      "Mounting: wall-mounted (most common) or roof-mounted",
      "Spanish Sauleda fabric: 19 solids + 18 stripes (10+ years expected life)",
      "3-year warranty on the whole awning, fabric included"
    ],
    "dimensions": [
      {
        "spec": "Width range",
        "value": "2.0 m to 6.0 m",
        "_id": "69fc783c2bf7668b2547e34a"
      },
      {
        "spec": "Projection range",
        "value": "1.5 m to 4 m (deepest in range)",
        "_id": "69fc783c2bf7668b2547e34b"
      },
      {
        "spec": "Maximum single set (W × P)",
        "value": "6.0 m × 4 m",
        "_id": "69fc783c2bf7668b2547e34c"
      },
      {
        "spec": "Minimum single set (W × P)",
        "value": "2.0 m × 1.5 m",
        "_id": "69fc783c2bf7668b2547e34d"
      },
      {
        "spec": "Aluminium arm width",
        "value": "82.13 mm (largest in range)",
        "_id": "69fc783c2bf7668b2547e34e"
      },
      {
        "spec": "Aluminium arm thickness",
        "value": "42.21 mm (largest in range)",
        "_id": "69fc783c2bf7668b2547e34f"
      },
      {
        "spec": "Profile thickness",
        "value": "3.27 mm (thickest in range)",
        "_id": "69fc783c2bf7668b2547e350"
      },
      {
        "spec": "Cassette enclosure",
        "value": "No - straight valance with corner cutouts",
        "_id": "69fc783c2bf7668b2547e351"
      },
      {
        "spec": "Arm mechanism",
        "value": "Stainless steel chain interlink, double plate bracket",
        "_id": "69fc783c2bf7668b2547e352"
      },
      {
        "spec": "LED",
        "value": "Not available",
        "_id": "69fc783c2bf7668b2547e353"
      },
      {
        "spec": "Arm reinforcement",
        "value": "Thickened, widened heavy-gauge arms",
        "_id": "69fc783c2bf7668b2547e354"
      },
      {
        "spec": "Operation",
        "value": "Manual",
        "_id": "69fc783c2bf7668b2547e355"
      },
      {
        "spec": "Mounting",
        "value": "Wall (standard) or ceiling",
        "_id": "69fc783c2bf7668b2547e356"
      }
    ],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [
      {
        "width": 2,
        "projection": 1,
        "price": 580,
        "pre_discount_price": null
      },
      {
        "width": 2.5,
        "projection": 1,
        "price": 640,
        "pre_discount_price": null
      },
      {
        "width": 3,
        "projection": 2,
        "price": 730,
        "pre_discount_price": null
      },
      {
        "width": 4,
        "projection": 3,
        "price": 850,
        "pre_discount_price": null
      },
      {
        "width": 5,
        "projection": 4,
        "price": 1090,
        "pre_discount_price": null
      },
      {
        "width": 6,
        "projection": 4,
        "price": 1310,
        "pre_discount_price": null
      }
    ],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "69fb357063740f19a0cfd86a",
    "name": "B05 Traditional Scalloped Awning",
    "slug": "b05-traditional-scalloped-awning",
    "category": "awning",
    "sort_order": 4,
    "in_stock": false,
    "price_from": 1000,
    "pre_discount_price": null,
    "short_description": "Traditional scalloped retractable awning with a choice of white or frosted black finish. Stainless steel chain link arms, decorative scalloped valance, up to 6 m × 3 m. Manual operation. Free delivery to most of Melbourne.",
    "description": "The B05 is the colour-customisable mid-tier of the range - the only awning in the lineup with an explicit choice of arm and frame finish: classic white or frosted black. The scalloped valance gives the front bar a traditional decorative silhouette that suits the broadest mix of Australian homes. Curved aluminium arms are thickened and widened for a more secure rear pipe installation, and stainless steel chain links at the joints deliver more elasticity and longer life than basic wire-link mechanisms. 8-component arm set keeps the system robust without adding cassette weight. Maximum coverage from a single set is 6 m wide × 3 m projection. Manual operation. Free delivery to local Melbournians, and a 3-year warranty on the whole awning, fabric included.",
    "images": [
      "/uploads/products/image-b05-thumbnail-v1.webp",
      "/uploads/products/b05-clean.webp",
      "/uploads/products/b05-restaurant.webp",
      "/uploads/products/b05-family.webp"
    ],
    "specs": [
      "From $1,000 - free local Melbourne delivery",
      "Maximum single set: 6 m × 3 m (width × projection)",
      "Operation: manual",
      "Frame finish: white OR frosted black (your choice)",
      "Stainless steel chain link joints (premium durability)",
      "Thickened and widened curved arms with secure rear pipe",
      "Aluminium arms: 65.14 mm × 32.13 mm",
      "1.44 mm slim profile",
      "Decorative scalloped valance",
      "8-component arm set",
      "Mounting: wall-mounted (most common) or roof-mounted",
      "Spanish Sauleda fabric: 19 solids + 18 stripes (10+ years expected life)",
      "3-year warranty on the whole awning, fabric included"
    ],
    "dimensions": [
      {
        "spec": "Width range",
        "value": "2.0 m to 6.0 m",
        "_id": "69fc783c2bf7668b2547e39b"
      },
      {
        "spec": "Projection range",
        "value": "1.5 m to 3 m",
        "_id": "69fc783c2bf7668b2547e39c"
      },
      {
        "spec": "Maximum single set (W × P)",
        "value": "6.0 m × 3 m",
        "_id": "69fc783c2bf7668b2547e39d"
      },
      {
        "spec": "Minimum single set (W × P)",
        "value": "2.0 m × 1.5 m",
        "_id": "69fc783c2bf7668b2547e39e"
      },
      {
        "spec": "Aluminium arm width",
        "value": "65.14 mm",
        "_id": "69fc783c2bf7668b2547e39f"
      },
      {
        "spec": "Aluminium arm thickness",
        "value": "32.13 mm",
        "_id": "69fc783c2bf7668b2547e3a0"
      },
      {
        "spec": "Profile thickness",
        "value": "1.44 mm (slim)",
        "_id": "69fc783c2bf7668b2547e3a1"
      },
      {
        "spec": "Cassette enclosure",
        "value": "No - scalloped valance",
        "_id": "69fc783c2bf7668b2547e3a2"
      },
      {
        "spec": "Arm mechanism",
        "value": "Stainless steel chain link",
        "_id": "69fc783c2bf7668b2547e3a3"
      },
      {
        "spec": "Frame finish options",
        "value": "White or frosted black",
        "_id": "69fc783c2bf7668b2547e3a4"
      },
      {
        "spec": "LED",
        "value": "Not available",
        "_id": "69fc783c2bf7668b2547e3a5"
      },
      {
        "spec": "Component count",
        "value": "8-part arm set",
        "_id": "69fc783c2bf7668b2547e3a6"
      },
      {
        "spec": "Operation",
        "value": "Manual",
        "_id": "69fc783c2bf7668b2547e3a7"
      },
      {
        "spec": "Mounting",
        "value": "Wall (standard) or ceiling",
        "_id": "69fc783c2bf7668b2547e3a8"
      }
    ],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [
      {
        "width": 2,
        "projection": 1,
        "price": 548,
        "pre_discount_price": null
      },
      {
        "width": 2.5,
        "projection": 2,
        "price": 610,
        "pre_discount_price": null
      },
      {
        "width": 3,
        "projection": 2,
        "price": 640,
        "pre_discount_price": null
      },
      {
        "width": 4,
        "projection": 3,
        "price": 810,
        "pre_discount_price": null
      },
      {
        "width": 5,
        "projection": 3,
        "price": 990,
        "pre_discount_price": null
      },
      {
        "width": 6,
        "projection": 3,
        "price": 1210,
        "pre_discount_price": null
      }
    ],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "69fb357063740f19a0cfd872",
    "name": "K3 Heritage Mediterranean Awning",
    "slug": "k3-heritage-mediterranean-awning",
    "category": "awning",
    "sort_order": 5,
    "in_stock": false,
    "price_from": 1000,
    "pre_discount_price": null,
    "short_description": "Heritage Mediterranean-style retractable awning with a traditional pointed-tab valance. Aluminium curved arms with thickened joint heads, up to 6 m × 3 m. Perfect for Federation, period weatherboard, cottage, and Mediterranean villa homes. Free delivery to most of Melbourne.",
    "description": "The K3 is the heritage entry-tier of the ASG range - chosen on aesthetic. The traditional pointed (triangular tab) valance is the signature European Mediterranean awning silhouette and reads instantly correct on Federation, period weatherboard, cottage, and Mediterranean villa homes. The mechanism is intentionally simple and proven: aluminium curved arms with double wire links at the joints, thickened arms and joint heads for long service life, and a slim 1.32 mm profile that keeps the system visually quiet against period facades. 6-component arm set - the simplest construction in the range. Maximum coverage from a single set is 6 m wide × 3 m projection. Manual operation. Free delivery to local Melbournians, and a 3-year warranty on the whole awning, fabric included.",
    "images": [
      "/images/products/awnings/awning-k3-stock-v3.webp",
      "/uploads/products/k3-clean.webp",
      "/uploads/products/k3-family.webp",
      "/uploads/products/k3-restaurant.webp"
    ],
    "specs": [
      "From $1,000 - free local Melbourne delivery",
      "Maximum single set: 6 m × 3 m (width × projection)",
      "Operation: manual",
      "Pointed / triangular tab valance (Mediterranean heritage style)",
      "Aluminium curved arms with thickened joint heads",
      "Double wire link joint mechanism (basic but proven)",
      "Aluminium arms: 64.15 mm × 33.06 mm",
      "1.32 mm slim profile",
      "6-component arm set (simplest construction in the range)",
      "Mounting: wall-mounted (most common) or roof-mounted",
      "Spanish Sauleda fabric: 19 solids + 18 stripes (10+ years expected life)",
      "3-year warranty on the whole awning, fabric included"
    ],
    "dimensions": [
      {
        "spec": "Width range",
        "value": "2.0 m to 6.0 m",
        "_id": "69fc783c2bf7668b2547e3ec"
      },
      {
        "spec": "Projection range",
        "value": "1.5 m to 3 m",
        "_id": "69fc783c2bf7668b2547e3ed"
      },
      {
        "spec": "Maximum single set (W × P)",
        "value": "6.0 m × 3 m",
        "_id": "69fc783c2bf7668b2547e3ee"
      },
      {
        "spec": "Minimum single set (W × P)",
        "value": "2.0 m × 1.5 m",
        "_id": "69fc783c2bf7668b2547e3ef"
      },
      {
        "spec": "Aluminium arm width",
        "value": "64.15 mm",
        "_id": "69fc783c2bf7668b2547e3f0"
      },
      {
        "spec": "Aluminium arm thickness",
        "value": "33.06 mm",
        "_id": "69fc783c2bf7668b2547e3f1"
      },
      {
        "spec": "Profile thickness",
        "value": "1.32 mm (slimmest in range)",
        "_id": "69fc783c2bf7668b2547e3f2"
      },
      {
        "spec": "Cassette enclosure",
        "value": "No - pointed/triangular tab valance",
        "_id": "69fc783c2bf7668b2547e3f3"
      },
      {
        "spec": "Arm mechanism",
        "value": "Double wire link (basic, proven)",
        "_id": "69fc783c2bf7668b2547e3f4"
      },
      {
        "spec": "LED",
        "value": "Not available",
        "_id": "69fc783c2bf7668b2547e3f5"
      },
      {
        "spec": "Component count",
        "value": "6-part arm set (simplest in range)",
        "_id": "69fc783c2bf7668b2547e3f6"
      },
      {
        "spec": "Operation",
        "value": "Manual",
        "_id": "69fc783c2bf7668b2547e3f7"
      },
      {
        "spec": "Mounting",
        "value": "Wall (standard) or ceiling",
        "_id": "69fc783c2bf7668b2547e3f8"
      }
    ],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [
      {
        "width": 2,
        "projection": 1,
        "price": 580,
        "pre_discount_price": null
      },
      {
        "width": 2.5,
        "projection": 1,
        "price": 640,
        "pre_discount_price": null
      },
      {
        "width": 3,
        "projection": 2,
        "price": 730,
        "pre_discount_price": null
      },
      {
        "width": 4,
        "projection": 3,
        "price": 850,
        "pre_discount_price": null
      },
      {
        "width": 5,
        "projection": 3,
        "price": 1090,
        "pre_discount_price": null
      },
      {
        "width": 6,
        "projection": 3,
        "price": 1310,
        "pre_discount_price": null
      }
    ],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "69c10ed6c2b88107d183301b",
    "name": "Pergola 175",
    "slug": "pergola-175",
    "category": "louvered",
    "sort_order": 10,
    "in_stock": true,
    "price_from": 4550,
    "pre_discount_price": null,
    "short_description": "Our standard louvered pergola - the perfect balance of performance, size flexibility, and value.",
    "description": "The Pergola 175 is our most popular model and the go-to choice for Australian homes and businesses. Featuring wider 175mm double-layer aluminium louvers with integrated drainage channels, it handles heavy rain, strong winds, and snow loads up to 100kg per square metre. The separate beam and sink design allows for a clean, streamlined look while maximising water management. Available in electric or manual operation with optional LED light strips. Sizes from 2m x 2m up to 5m x 3.5m - fully customisable to your space.",
    "images": [
      "/uploads/gallery/pergola-175-4x3.webp",
      "/images/products/pergola-175-app1.webp",
      "/images/products/pergola-175-app2.webp",
      "/uploads/gallery/pergola-175-3x3.webp",
      "/uploads/gallery/pergola-175-4x4.webp",
      "/uploads/gallery/pergola-175-5x5.webp",
      "/uploads/gallery/pergola-175-4x3.webp",
      "/uploads/gallery/pergola-175-5x4.webp"
    ],
    "specs": [
      "Material: 6063 Aluminium Alloy",
      "Louver Size: 175 x 40 x 1.5mm",
      "Beam Size: 175 x 40 x 1.8mm",
      "Sink Size: 55 x 82 x 1.4mm",
      "Post Size: 150 x 150 x 2.0mm (or 180 x 180 x 2.5mm)",
      "Max Blade Length: 4 metres",
      "Snow Load: 100kg/m²",
      "Wind Resistance: Level 10 (fully closed)",
      "Surface: High-density powder coating",
      "Drive: Electric or Manual",
      "Drainage: Dual hidden drainage system",
      "Colours: Grey, White, Coffee, Black"
    ],
    "dimensions": [],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "69c10ed6c2b88107d1833022",
    "name": "Pergola 163",
    "slug": "pergola-163",
    "category": "louvered",
    "sort_order": 10,
    "in_stock": true,
    "price_from": 3750,
    "pre_discount_price": null,
    "short_description": "Compact louvered pergola - ideal for smaller courtyards, patios, and terraces.",
    "description": "The Pergola 163 delivers the same intelligent louvered roof technology in a more compact form. Made from high-strength 6063 aluminium alloy with corrosion-resistant, UV-proof powder coating, it is lightweight yet strong. The 163mm double-layer flat louvers offer one-touch control to switch between full shade and open ventilation. A modern, minimalist design that suits courtyards, terraces, and balconies. Available in fixed sizes with flat or beveled louver options.",
    "images": [
      "/uploads/products/pergola-163-card-v4.webp",
      "/images/products/pergola-163-hero.webp",
      "/images/products/pergola-163-app1.webp",
      "/images/products/pergola-163-app2.webp"
    ],
    "specs": [
      "Material: 6063 Aluminium Alloy",
      "Louver Size: 163 x 35.3 x 1.25mm",
      "Beam + Sink: 152 x 90 x 1.5mm (integrated)",
      "Post Size: 120 x 120 x 1.4mm",
      "Max Blade Length: 4 metres",
      "Wind Resistance: Level 10 (fully closed)",
      "Surface: High-density powder coating",
      "Drive: Electric, Manual, or Colour Light Strip",
      "Drainage: Hidden drainage system",
      "Louver Options: Double-layer Flat, Beveled, or Curved Single-layer",
      "Standard Sizes: 3x3m, 3x4m, 3x6m, 4x4m",
      "Colours: Grey, White, Coffee, Black"
    ],
    "dimensions": [],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "69c10ed6c2b88107d1833030",
    "name": "Pergola 180 Retractable",
    "slug": "pergola-180-retractable",
    "category": "retractable",
    "sort_order": 10,
    "in_stock": true,
    "price_from": 5625,
    "pre_discount_price": null,
    "short_description": "Retractable louvered pergola - fold the roof open for an unobstructed view of the sky.",
    "description": "The Pergola 180 takes outdoor living to the next level with a fully retractable roof. Unlike fixed louver pergolas, the 180 lets you fold the entire roof open at the touch of a button - giving you a completely unobstructed view of the sky. When closed, the blades are 100% rainproof and wind-resistant. The polyurethane synchronisation belt with 14 embedded steel wires ensures smooth, quiet, and reliable operation for years. Perfect for entertaining areas, pool surrounds, and rooftop terraces.",
    "images": [
      "/uploads/products/pergola-180-card.webp",
      "/images/products/pergola-180-hero.webp",
      "/images/products/pergola-180-app1.webp",
      "/images/products/pergola-180-app2.webp"
    ],
    "specs": [
      "Material: Aluminium Alloy",
      "Louver Size: 181 x 40 x 1.2mm",
      "Beam Size: 175 x 40 x 1.8mm",
      "Track Beam: 173 x 40 x 1.6mm",
      "Sink Size: 82 x 55 x 1.4mm",
      "Wind Resistance: Level 10 (fully closed)",
      "Snow Load: 100kg/m²",
      "Surface: High-density powder coating",
      "Drive: Electric with remote / smart control",
      "Sync Belt: Polyurethane with 14 steel wires",
      "Drainage: Hidden drainage system",
      "Colours: Grey, White, Coffee, Black"
    ],
    "dimensions": [],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  }
];

export const fallbackAccessories = [
  {
    "noindex": false,
    "_id": "6ab8e60c78f266acb28563b1",
    "name": "Awning Wi-Fi Controller",
    "slug": "awning-wi-fi-controller",
    "category": "accessory",
    "sort_order": 0,
    "in_stock": true,
    "price_from": 75,
    "pre_discount_price": null,
    "short_description": "Open and close your motorised awning from your phone. Pairs with the AW01 and B06, alongside the remote that comes with them.",
    "description": "The Wi-Fi controller adds phone control to a motorised awning. It connects to your home Wi-Fi and pairs with the Dooya motor in the AW01 Full Cassette Awning and the B06 Premium Open-Arm Awning, so you can open and close the awning from your phone as well as from the remote supplied with it.",
    "images": [
      "/uploads/products/awning-wifi-controller.webp"
    ],
    "specs": [
      "Control the awning from your phone",
      "Pairs with the AW01 and B06 Dooya motors",
      "Works alongside the supplied remote"
    ],
    "dimensions": [],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": false,
    "_id": "6ab27c5674ae0595fc5465e3",
    "name": "Awning Wind and Sun Sensor",
    "slug": "awning-wind-and-sun-sensor",
    "category": "accessory",
    "sort_order": 6,
    "in_stock": true,
    "price_from": 150,
    "pre_discount_price": null,
    "short_description": "Wall-mounted wind, sun and rain sensor that retracts your awning on its own. Solar powered, wireless, and included free with every AW01. Valued at $150.",
    "description": "The DC8811 is the wireless weather sensor that lets a motorised awning look after itself. It fixes to the wall with two screws, charges from a solar panel on its back, and talks to the awning motor over the same 433 MHz radio your remote uses, so nothing is wired into the awning and nothing is wired into the house. Set a wind speed and the awning retracts on its own when the wind gets up, whether you are home or not. Set a light level and it extends when the sun comes round, then retracts again when the light drops away. Switch the rain function on and it brings the awning in when the detection grid on the back gets wet. Every AW01 Full Cassette Awning ships with one included - a $150 value that most suppliers charge extra for - and it also pairs with the B06 Premium Open-Arm Awning and any awning in our range running a Dooya E-type, ED-type or R-type tubular motor. A wind sensor is an aid, not a substitute for judgement: retract the awning by hand when a storm is forecast or when you are going away.",
    "images": [
      "/uploads/products/wind-sensor-dc8811-v3.webp",
      "/uploads/products/wind-sensor-dc8811-detail.webp",
      "/uploads/products/wind-sensor-dc8811-display.webp",
      "/uploads/products/wind-sensor-dc8811-lcd.webp",
      "/uploads/products/wind-sensor-dc8811-mounting.webp"
    ],
    "specs": [
      "Included free with every AW01 Full Cassette Awning - valued at $150",
      "Retracts the awning automatically above the wind speed you set",
      "Optional sun tracking and rain detection, both switchable",
      "Solar powered - nothing wired to the awning or the switchboard",
      "Fixes to the wall with two screws",
      "Also pairs with the B06 Premium Open-Arm Awning",
      "Wind setting 0 to 180 km/h, light setting 0 to 100 klux",
      "Installation and set-up guide free to download below"
    ],
    "dimensions": [
      {
        "spec": "Model",
        "value": "Dooya DC8811",
        "_id": "6ab27c5674ae0595fc5465e9"
      },
      {
        "spec": "Type",
        "value": "Wireless wind, sun and rain sensor",
        "_id": "6ab27c5674ae0595fc5465ea"
      },
      {
        "spec": "Power",
        "value": "Rechargeable battery, solar panel on the rear face, USB Type-C charging",
        "_id": "6ab27c5674ae0595fc5465eb"
      },
      {
        "spec": "Input voltage",
        "value": "3.7 V DC",
        "_id": "6ab27c5674ae0595fc5465ec"
      },
      {
        "spec": "Working current",
        "value": "Less than 20 mA",
        "_id": "6ab27c5674ae0595fc5465ed"
      },
      {
        "spec": "Radio frequency",
        "value": "433.05 to 434.79 MHz",
        "_id": "6ab27c5674ae0595fc5465ee"
      },
      {
        "spec": "Radio range",
        "value": "100 m in open air, 40 m inside a building",
        "_id": "6ab27c5674ae0595fc5465ef"
      },
      {
        "spec": "Security",
        "value": "Security code with 50 million combinations",
        "_id": "6ab27c5674ae0595fc5465f0"
      },
      {
        "spec": "Wind setting",
        "value": "0 to 180 km/h",
        "_id": "6ab27c5674ae0595fc5465f1"
      },
      {
        "spec": "Light setting",
        "value": "0 to 100 klux",
        "_id": "6ab27c5674ae0595fc5465f2"
      },
      {
        "spec": "Rain setting",
        "value": "On or off",
        "_id": "6ab27c5674ae0595fc5465f3"
      },
      {
        "spec": "Sampling",
        "value": "Wind every 2 seconds, light every 20 seconds. Wind takes priority",
        "_id": "6ab27c5674ae0595fc5465f4"
      },
      {
        "spec": "Working temperature",
        "value": "-10 °C to +60 °C",
        "_id": "6ab27c5674ae0595fc5465f5"
      },
      {
        "spec": "Mounting",
        "value": "Two screws, to a wall or a soffit",
        "_id": "6ab27c5674ae0595fc5465f6"
      },
      {
        "spec": "Works with",
        "value": "Dooya E-type, ED-type and R-type tubular motors; DC136, DC8807 and DC1600 receivers",
        "_id": "6ab27c5674ae0595fc5465f7"
      },
      {
        "spec": "Supplied with",
        "value": "Every AW01 Full Cassette Awning, free. Valued at $150",
        "_id": "6ab27c5674ae0595fc5465f8"
      }
    ],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": true,
    "_id": "69b7f8da2a88efacad1936aa",
    "name": "Glass Walls & Screens",
    "slug": "glass-walls-screens",
    "category": "accessory",
    "sort_order": 10,
    "in_stock": true,
    "price_from": null,
    "pre_discount_price": null,
    "short_description": "Frameless glass panels and retractable mesh screens that provide wind protection and insect control without blocking the view.",
    "description": "Frameless glass panels and retractable mesh screens that provide wind protection and insect control without blocking the view.",
    "images": [
      "/images/products/glass-walls-uploaded.webp",
      "/images/products/glass-walls-hero.webp"
    ],
    "specs": [
      "Frameless glass",
      "Mesh screens",
      "Wind protection"
    ],
    "dimensions": [],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": true,
    "_id": "69b7f8da2a88efacad1936ab",
    "name": "Blinds & Shutters",
    "slug": "blinds-shutters",
    "category": "accessory",
    "sort_order": 11,
    "in_stock": true,
    "price_from": null,
    "pre_discount_price": null,
    "short_description": "Motorised zip-track blinds and aluminium shutters for privacy, shade and weather protection on any side of your pergola.",
    "description": "Motorised zip-track blinds and aluminium shutters for privacy, shade and weather protection on any side of your pergola.",
    "images": [
      "/images/products/blinds-screens-uploaded.webp",
      "/images/products/blinds-screens-hero.webp"
    ],
    "specs": [
      "Zip-track blinds",
      "Aluminium shutters",
      "Motorised"
    ],
    "dimensions": [],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  },
  {
    "noindex": true,
    "_id": "69b7f8da2a88efacad1936ac",
    "name": "LED Lighting & Heaters",
    "slug": "led-lighting-heaters",
    "category": "accessory",
    "sort_order": 12,
    "in_stock": true,
    "price_from": null,
    "pre_discount_price": null,
    "short_description": "Integrated LED strip lighting and infrared heaters that extend your outdoor entertaining well into the evening and cooler months.",
    "description": "Integrated LED strip lighting and infrared heaters that extend your outdoor entertaining well into the evening and cooler months.",
    "images": [
      "/images/products/led-heaters-uploaded.webp",
      "/images/products/led-heaters-hero.webp"
    ],
    "specs": [
      "LED strips",
      "Infrared heaters",
      "Dimmable"
    ],
    "dimensions": [],
    "video_mp4": "",
    "video_webm": "",
    "video_poster": "",
    "variant_prices": [],
    "rrpPrice": null,
    "salePrice": null,
    "saleStartsAt": null,
    "saleEndsAt": null,
    "saleLabel": null
  }
];

export const fallbackBlogPosts = [
  {
    "_id": "6ab78bcb341ea3500f230001",
    "slug": "how-to-install-an-awning-into-hollow-brick",
    "title": "How to Install an Awning into Hollow Brick",
    "excerpt": "Hollow brick will not hold an expanding anchor. Here is how a chemical anchor and a sieve sleeve fix that, what you need to buy, and how long to leave it before you hang anything on it.",
    "featured_image": "/uploads/content/blog-install-drilling.jpg",
    "published_at": "2026-09-26T09:09:31.975Z",
    "tags": [
      "awnings",
      "installation",
      "diy",
      "hollow brick",
      "chemical anchor"
    ],
    "seo_title": "How to Install an Awning into Hollow Brick | Chemical Anchors | ASG",
    "seo_description": "Fixing an awning to hollow or perforated brick with a chemical anchor: sieve sleeves, hole prep, the gun and studs you need, and cure times by wall temperature.",
    "content": "<p class=\"tldr\"><strong>TL;DR:</strong> Hollow brick will not hold an expanding anchor. Use a chemical anchor with a sieve sleeve: drill, clean the hole properly, inject resin, twist the stud in, and leave it alone until it has cured. Everything else about the install is the same, and the rest of the steps are in <a href=\"/blog/how-to-install-a-retractable-awning-into-solid-brick\">the main guide</a>.</p>\n\n<h2>Why hollow brick is its own problem</h2>\n\n<p>Most Melbourne brick veneer built since the 1970s is hollow: the bricks have cores through them, and behind the skin is a cavity. An expanding anchor has nothing solid to expand against in that, so it feels tight on the spanner and then pulls out under load. This is the substrate that fails awnings.</p>\n\n<p>The fix is a chemical anchor, sold as chemset or injection anchor. It is a two-part resin in a cartridge, polyester or vinylester or epoxy depending on the product, with a mixing nozzle that combines the two parts as you squeeze. Paired with a sieve sleeve, a plastic mesh tube that drops into the hole, the resin extrudes out through the mesh, fills the brick cores, and sets into a key that cannot be pulled back through. The fixing holds on the shape of the cured resin rather than on friction.</p>\n\n<h2>What you need</h2>\n\n<ul>\n<li><strong>The resin cartridge</strong> and a spare mixing nozzle. The resin sets inside the nozzle between holes if you stop for long, so buy more nozzles than you think.</li>\n<li><strong>A gun that matches the cartridge.</strong> The size decides this. Ramset sell ChemSet 101 Plus in a 600ml cartridge, and that one needs Ramset's own dispensing gun; a standard silicone gun will not take it. The smaller cartridges in the same range are silicone-tube sized and go into the gun most people already own. Check the box against your gun before you get to the wall.</li>\n<li><strong>Sieve sleeves</strong> sized to the hole, one per anchor.</li>\n<li><strong>Threaded rod or studs, bought separately.</strong> A resin cartridge is resin and mixing nozzles, nothing else. The 600ml ChemSet 101 Plus ships with two nozzles and no studs. Hold a bolt up to the bracket hole to size it, or measure the hole: M12 suits most brackets of this type, but the bracket decides, not the habit.</li>\n<li><strong>A hammer drill</strong> with a masonry bit. This is the tool with a hammer action for drilling into brick, not an impact driver, which is for driving screws and will get you nowhere in masonry.</li>\n<li><strong>A blow pump and a round wire brush</strong> matched to the hole diameter.</li>\n</ul>\n\n<h2>How to set one</h2>\n\n<ol>\n<li>Drill the hole to the diameter and depth the resin calls for, on hammer for the brick face. Drill square to the wall.</li>\n<li>Clean it properly. Blow, brush, blow, brush, blow. Dust is a release agent: a dusty hole can lose most of the anchor's rated load, and it is the single most common reason a chemical fixing fails.</li>\n<li>Push the sieve sleeve in until it sits flush.</li>\n<li>Discard the first few centimetres of resin until the colour runs even. Until both parts are mixing, what comes out will not cure.</li>\n<li>Inject from the back of the sleeve outwards, filling about two thirds. Pull the nozzle back as it fills so you are not trapping air.</li>\n<li>Push the rod in with a slow twisting motion so the resin works around the thread. Resin should just appear at the mouth of the hole. Wipe the excess before it goes off.</li>\n<li>Leave it alone. Do not touch, load or adjust the rod while it gels.</li>\n</ol>\n\n<h2>How long to leave it</h2>\n\n<p>Two clocks run. <strong>Working time</strong> is how long you have between injecting and seating the rod. <strong>Cure time</strong> is how long before you can hang anything on it. Both move with temperature, and what matters is the temperature of the wall, not the air. A shaded south wall in July is colder than the forecast; a west wall in February is a lot hotter.</p>\n\n<table>\n<thead><tr><th>Wall temperature</th><th>Working time</th><th>Before loading</th></tr></thead>\n<tbody>\n<tr><td>35°C and up</td><td data-label=\"Working time\">About 2 minutes</td><td data-label=\"Before loading\">30 minutes</td></tr>\n<tr><td>20°C</td><td data-label=\"Working time\">About 6 minutes</td><td data-label=\"Before loading\">45 minutes</td></tr>\n<tr><td>10°C</td><td data-label=\"Working time\">About 15 minutes</td><td data-label=\"Before loading\">2 hours</td></tr>\n<tr><td>5°C</td><td data-label=\"Working time\">About 25 minutes</td><td data-label=\"Before loading\">3 hours</td></tr>\n<tr><td>0°C</td><td data-label=\"Working time\">About 45 minutes</td><td data-label=\"Before loading\">5 hours or more</td></tr>\n</tbody>\n</table>\n\n<p>Ramset quote ChemSet 101 Plus at 50 minutes to full cure at 20°C, which sits close to the middle row. Treat the rest as the shape of it, not as your numbers. Resins differ by a factor of two or three, so the figures printed on your cartridge are the ones that count. Below about 5°C many standard resins will not cure at all and you need a winter grade. On a hot wall you can lose the working time before the rod is home, so mix one anchor at a time.</p>\n\n<p>When in doubt, give it longer. Nothing goes wrong from waiting; a rod turned or loaded while the resin is still green never reaches its rated load, and it will not tell you.</p>\n\n<h2>The part that still needs a professional</h2>\n\n<p>A chemical anchor makes hollow brick fixable. It does not tell you whether your wall can carry the awning. The whole weight sits on two bracket points, and the rated pull-out of a resin anchor in perforated brick is well below the same anchor in solid brick or concrete. Someone has to confirm the rated load at your bracket spacing exceeds what the awning puts into it, and that is a calculation against the resin manufacturer's data for your brick type.</p>\n\n<p>If you cannot identify the brick, or the wall is render or cladding over a cavity and you cannot see what is behind it, stop and get engineering advice. That is the point in the manual where it says exactly the same thing.</p>\n\n<h2>The rest of the install</h2>\n\n<p>Nothing else changes. Measuring the arm spacing, marking a level line, lifting the cassette on, pairing the remote and setting the pitch all run the same way whatever the wall is made of. Those steps are in <a href=\"/blog/how-to-install-a-retractable-awning-into-solid-brick\">How to Install a Retractable Awning into Solid Brick</a>.</p>\n\n<p>If you would rather hand the whole thing over, <a href=\"/blog/do-you-need-an-installer-for-an-awning\">Do You Need an Installer for an Awning?</a> covers where that line sits. Bracket spacing and load figures are on the <a href=\"/for-installers\">installer page</a>.</p>"
  },
  {
    "_id": "6ab783f6e2d3160a9fb6d6f7",
    "slug": "how-to-install-a-retractable-awning-into-solid-brick",
    "title": "How to Install a Retractable Awning into Solid Brick",
    "excerpt": "The seven steps from our installation manual, in order: measure the arm spacing, mark a level line, fix the brackets, lift the cassette on, pair the remote, set the pitch, check everything twice.",
    "featured_image": "/uploads/content/blog-install-fitting.jpg",
    "published_at": "2026-09-26T08:36:06.310Z",
    "tags": [
      "awnings",
      "installation",
      "diy",
      "how to"
    ],
    "seo_title": "How to Install a Retractable Awning into Solid Brick | ASG Shading",
    "seo_description": "Step by step retractable awning installation into solid brick: bracket spacing, drilling, lifting the cassette, pairing the remote and setting the pitch.",
    "content": "<p class=\"tldr\"><strong>TL;DR:</strong> Measure the arm spacing off the awning itself, strike a level line, fix two brackets (three from 4 metres wide) into solid masonry, lift the cassette on and clip it, pair the remote, set the pitch. Two people under 4 metres wide and three from 4 metres. Budget an hour once the brackets are marked, and read the manual before you drill.</p>\n\n<h2>Before anyone goes up a ladder</h2>\n\n<p>Three things decide whether this is a job you should be doing.</p>\n\n<ul>\n<li><strong>People.</strong> Two competent adults minimum. Three for awnings 4 metres wide or more, or for any lift above shoulder height.</li>\n<li><strong>The wall.</strong> This guide assumes solid load-bearing masonry, concrete or an engineered structural member, because that is what the supplied anchors are for. Hollow brick needs <a href=\"/blog/how-to-install-an-awning-into-hollow-brick\">a chemical anchor instead</a>. Cladding, render over a cavity and mud brick all need engineering advice before anyone drills.</li>\n<li><strong>The parts.</strong> Check everything against the parts list first. A standard single-motor awning ships with the cassette, two brackets and eight fixings (three brackets and twelve fixings from 4 metres wide), the remote and the motor adjustment rod. Wider units come with extra brackets.</li>\n</ul>\n\n<p>You will need a hammer drill, a spirit or laser level, a tape, a 6mm hex key, open and hex wrenches, a pencil and two ladders. Safety glasses and gloves throughout.</p>\n\n<h2>Step 1. Measure the awning, not the wall</h2>\n\n<p>Connect power and run the awning out a few centimetres so the arm bases are visible. Measure X, the distance between the centres of the two arm bases: that is your bracket spacing. Measure Y and Z, from each arm base to its end of the cassette. Those are the end clearances the wall has to give you.</p>\n\n<p>Find the load point sticker on the back of the cassette. Each bracket sits directly under one. A bracket offset from the load point twists the cassette, and then either the arm sags or the fixing pulls out.</p>\n\n<h2>Step 2. Set out and mark</h2>\n\n<p>Pick the mounting height and check the front bar clearance at full projection before you commit. The awning drops as it extends, so doors, windows and paths have to stay clear at the far end of the travel, not just at the wall.</p>\n\n<p>Strike a level line at that height with a laser or spirit level. Do not work off a window head, an eave or a brick course, because none of them are reliably level. Mark the two bracket centres on the line at spacing X, keep both at least 10cm from any corner, and confirm the clear wall past each mark beats Y and Z.</p>\n\n<h2>Step 3. Drill and fix the brackets</h2>\n\n<p>Drill square to the wall, to full anchor depth plus a little clearance, with the bit diameter the supplied anchors call for. Then blow or vacuum every hole out. Dust left in the hole is the most common reason an anchor never reaches its rated load.</p>\n\n<p>Fit the anchors, hang the brackets, run the nuts finger tight, recheck level and projection, then tighten evenly. Eight fixings are supplied, four per bracket, and all eight go in. If the supplied anchors do not suit your substrate, stop and source an engineered alternative with a rated pull-out value rather than improvising.</p>\n\n<h2>What if the wall is hollow brick?</h2>\n\n<p>Then the supplied anchors are the wrong fixing and you need a chemical anchor instead. That is its own job, with its own tools and its own waiting time, so it has a guide of its own: <a href=\"/blog/how-to-install-an-awning-into-hollow-brick\">How to Install an Awning into Hollow Brick</a>. Come back here for the rest.</p>\n\n<h2>Step 4. Lift the cassette on</h2>\n\n<p>Take the retaining screws and cover clips off both brackets. Lift the cassette on with three people or mechanical help, seat the rail fully into each bracket slot, and check the engagement at both ends before anyone lets go.</p>\n\n<p>Refit the cover clips the right way round and tighten them. Until those clips are in, the cassette can lift out of the slot and fall, so never walk away from an unclipped awning. Check the drainage side faces down and that each arm base lines up vertically with its bracket.</p>\n\n<h2>Step 5. Power up and pair the remote</h2>\n\n<p>Switch the motor on. Press P2 on the back of the remote and the motor jogs. Press P2 again for a second jog, then press the up key for a third. Pairing is done.</p>\n\n<p>If it runs backwards or does nothing, start the sequence again. Do not press P2 while another motor on the same site is powered, or you will pair the wrong unit. Then run the awning fully out and fully in twice, watching that it stops cleanly at both ends and the fabric rolls on square without creeping to one side.</p>\n\n<h2>Step 6. Set the pitch</h2>\n\n<p>Extend the awning and sight along the front bar. It should sit parallel with the cassette and level end to end.</p>\n\n<p>The adjuster is in the middle of each bracket behind the cover clip. Put a 6mm hex key in: clockwise reduces pitch, anticlockwise increases it. Move both brackets by the same amount in small increments, sighting along the front bar between each one. Lifting the front bar by hand while you turn takes the weight off the mechanism and saves you rounding out the hex socket.</p>\n\n<p>Leave enough pitch for water to run off rather than pool.</p>\n\n<h2>Step 7. Final checks</h2>\n\n<ul>\n<li>Go back over every fixing: bracket anchors, clips, arm bolts, front bar screws.</li>\n<li>Fit the screw caps and peel the protective film off the profiles.</li>\n<li>Run it out and in one last time and confirm the front bar is level.</li>\n<li>Record the model, width, projection and fabric for your warranty.</li>\n</ul>\n\n<p>Have the fixings checked once a year and after any serious storm. Screws working loose is the usual reason a front bar drops out of line.</p>\n\n<h2>Not sure you want to do this yourself?</h2>\n\n<p>Plenty of people hand the job to a handyman, and some walls make that the only sensible call. <a href=\"/blog/do-you-need-an-installer-for-an-awning\">Do You Need an Installer for an Awning?</a> walks through where the line sits.</p>\n\n<p>The full manual, bracket spacing and load figures are on the <a href=\"/for-installers\">installer page</a>. If you want to see the whole fit before you start, the <a href=\"/products/aw01-full-box-awning\">AW01 Full Cassette Awning</a> page carries the three minute install video.</p>"
  },
  {
    "_id": "6ab781701ce35d3e4c3c2d41",
    "slug": "do-you-need-an-installer-for-an-awning",
    "title": "Do You Need an Installer for an Awning?",
    "excerpt": "Two people, a drill and about an hour covers most retractable awnings. Your wall, the width and the nearest power point decide whether you need a professional.",
    "featured_image": "/uploads/content/blog-install-electrician.jpg",
    "published_at": "2026-09-26T08:25:20.570Z",
    "tags": [
      "awnings",
      "installation",
      "diy"
    ],
    "seo_title": "Do You Need an Installer for an Awning? | ASG Shading Melbourne",
    "seo_description": "Most retractable awnings go up in about an hour with two people and no electrician. When you can fit it yourself, and when to call someone in.",
    "content": "<p class=\"tldr\"><strong>TL;DR:</strong> Most people fit a retractable awning themselves. Two people, a drill and about an hour. The motor comes with a standard plug, so there is no electrician and no hard wiring. Bring someone in if the wall is cavity brick or cladding, if the awning is 4 metres wide or more, or if there is no power point in reach. Pergolas are the exception and need a licensed builder.</p>\n\n<h2>The short answer</h2>\n\n<p>For a retractable awning, no. You need a second pair of hands, a drill and the right anchor for your wall. The rest is marking, bolting and lifting.</p>\n\n<p>For a pergola, yes. A pergola is a structure, and a suitably qualified and licensed builder has to put it up.</p>\n\n<h2>What the job actually is</h2>\n\n<p>Mark the wall. Fix two brackets. Lift the cassette on, seat it, set the pitch, plug it in. <a href=\"/blog/how-to-install-a-retractable-awning-into-solid-brick\">How to Install a Retractable Awning into Solid Brick</a> has the whole sequence step by step.</p>\n\n<ul>\n<li><strong>Two people</strong> under 4 metres wide. Three from 4 metres, or for any lift above shoulder height.</li>\n<li><strong>About an hour</strong> once the bracket positions are marked.</li>\n<li><strong>No electrician.</strong> The motor runs from a normal power point on a standard plug. Nothing is hard wired. Integrated LED lighting runs at 24V from the unit itself.</li>\n</ul>\n\n<p>The one job that does need a licensed electrician is a new power point, if there is nothing within reach of the opening.</p>\n\n<h2>Your wall decides more than the awning does</h2>\n\n<p>An awning hangs off two bracket points. What matters is the wall where those two brackets land, not the wall in general.</p>\n\n<ul>\n<li>Concrete, solid brick and structural timber take the supplied anchors.</li>\n<li>Hollow or cavity brick needs a chemical anchor with a sieve sleeve.</li>\n<li>Render or cladding over a cavity means the anchor has to reach past it to the structure behind.</li>\n<li>Mud brick, or a wall you cannot identify, needs engineering advice before anyone drills.</li>\n</ul>\n\n<p>Whoever drills the holes owns the fixing. If you cannot say what your wall is made of where the brackets go, that is the point to call a professional rather than the point to guess.</p>\n\n<h2>What comes with it</h2>\n\n<p>Every awning ships with the installation manual, and the full AW01 fit is on video in about three minutes: measuring and marking, fixing the brackets, lifting the cassette on, plugging it in, setting the pitch. Send the link to your handyman if you would rather not be up the ladder.</p>\n\n<p>We supply only, so we do not quote labour. That keeps the price down and it leaves the choice of who fits it with you.</p>\n\n<h2>So, installer or not?</h2>\n\n<p>Hire someone if any of these apply:</p>\n\n<ul>\n<li>The wall is cavity brick, render or cladding.</li>\n<li>The awning is 4 metres wide or more.</li>\n<li>There is no power point near the opening.</li>\n<li>You would rather not work at height.</li>\n</ul>\n\n<p>Otherwise, a competent DIYer and a helper will have it up before lunch. The <a href=\"/blog/how-to-install-a-retractable-awning-into-solid-brick\">step-by-step guide</a> is the one to read before you drill.</p>\n\n<p>Technical details for whoever does the work, including bracket spacing and load, are on the <a href=\"/for-installers\">installer page</a>. Wondering about council approval? Read <a href=\"/blog/do-you-need-a-permit-for-an-awning-in-melbourne\">Do You Need a Permit for an Awning in Melbourne?</a>. Or <a href=\"/contact\">ask us</a> and we will tell you what your opening needs.</p>"
  },
  {
    "_id": "6a0be9043bace94e6e423a81",
    "slug": "do-you-need-a-permit-for-an-awning-in-melbourne",
    "title": "Do You Need a Permit for an Awning in Melbourne?",
    "excerpt": "Most retractable awnings on a private Melbourne home need no building permit. Heritage overlays, encroachment over public land, commercial premises, Owners Corporations and fixed-roof awnings are the five exceptions.",
    "featured_image": "/uploads/gallery/aw01-charcoal-grey-v3.webp",
    "author_name": "ASG Shading",
    "author_credentials": "Melbourne awning and pergola specialist",
    "published_at": "2026-05-19T04:37:24.207Z",
    "tags": [
      "awnings",
      "permits",
      "melbourne",
      "retractable awnings",
      "heritage overlay",
      "building regulations",
      "victoria"
    ],
    "seo_title": "Awning Permits Melbourne - Do You Need One?",
    "seo_description": "Most retractable awnings on Melbourne homes don't need a permit - but heritage overlays, encroachment and commercial properties do. A plain-English ASG guide.",
    "content": "<p class=\"tldr\"><strong>TL;DR:</strong> A retractable awning bolted to the wall of a private Melbourne home usually needs no building permit. Victoria's Building Regulations 2018 treat it as a building appendage rather than a new structure. Five things change that: a heritage overlay, anything overhanging public land or a boundary, commercial premises, an Owners Corporation, and large fixed-roof awnings.</p>\n\n<h2>The short answer</h2>\n\n<p>No permit for the common case. A cassette or open-arm awning bolted to the brick or render of a private house, retracting into its housing when you are not using it, is an appendage to a wall that already exists. Nothing changes on the title.</p>\n\n<p>That covers most of what we supply, including the <a href=\"/products/aw01-full-box-awning\">AW01 Full Cassette</a>, the <a href=\"/products/b06-premium-open-arm-awning\">B06 Premium Open-Arm</a> and the <a href=\"/products/b05-traditional-scalloped-awning\">B05 Traditional Scalloped</a> on suburban homes.</p>\n\n<h2>You are clear if all of this is true</h2>\n\n<ul>\n<li>Private residential property, not strata and not commercial.</li>\n<li>The awning retracts. The canopy stows into a cassette or hood.</li>\n<li>It is wall-mounted to your own home rather than freestanding.</li>\n<li>Nothing overhangs a footpath, road, laneway or your neighbour's land.</li>\n<li>The property sits outside a heritage overlay.</li>\n<li>Projection under 3 metres in most municipalities.</li>\n<li>It does not redirect stormwater onto you or next door.</li>\n</ul>\n\n<h2>Five things that change the answer</h2>\n\n<h3>1. A heritage overlay</h3>\n\n<p>This catches more Melbourne homeowners than everything else here put together. Inside a Heritage Overlay, any change to the visible facade needs a planning permit from your council, and a wall-mounted awning counts.</p>\n\n<p>Check your address on the Victorian Government's VicPlan tool, or phone your council's planning department. Overlays are common through the inner north, inner east, inner west and the bayside suburbs, and across older outer suburbs with Federation and Victorian-era housing.</p>\n\n<p>Councils do approve awnings in overlays. They unbolt without damaging heritage fabric, which is the point officers care about. What gets assessed is the fabric colour, where it mounts, how visible the hardware is when retracted, and whether it comes off cleanly. Full-cassette models hide the mechanism, which heritage officers tend to prefer. Allow 6 to 10 weeks from application to decision.</p>\n\n<h3>2. Anything over public land or a boundary</h3>\n\n<p>If the awning projects over a footpath, road reserve, laneway or your neighbour's land, you need council consent even on a non-heritage property. The council issues a separate encroachment approval, sets a minimum clearance above the footpath, and asks for public liability insurance on the structure.</p>\n\n<p>Most awnings can be sized to stay entirely over your own land. Send us the boundary position and we will spec a projection that does.</p>\n\n<h3>3. Commercial premises</h3>\n\n<p>Cafes, shops and offices need a building permit and planning approval for a new awning, near enough regardless of size. Commercial awnings fall under BCA Volume One, with stricter wind load, fire and signage rules. Expect to engage a building surveyor and submit engineering certified to AS/NZS 1170.</p>\n\n<h3>4. Apartments, units and townhouses</h3>\n\n<p>Under an Owners Corporation you need written consent before you fix anything to a common-property wall, whether or not a council permit applies. Many buildings set conditions on colour and model. Get the consent in writing and have it name the model, fabric and mounting position, because a verbal yes from the OC manager is worth nothing once complaints start.</p>\n\n<h3>5. Large fixed awnings</h3>\n\n<p>A retractable awning is an appendage. A fixed, solid-roof cover over a deck is a verandah in building law, and that needs a building permit, structural engineering and a surveyor. The rough triggers are floor area over 20 m², roof height over 3.6 m, or any waterproof fixed roof.</p>\n\n<p>Our <a href=\"/products/a09-long-projection-awning\">A09 Long-Projection Awning</a> sits in the middle: still retractable and wall-mounted, but reaching up to 4 m. At the top of that range, check with your council before ordering.</p>\n\n<h2>Planning permit or building permit?</h2>\n\n<p>They are different documents and you may need one, both or neither. A <strong>planning permit</strong> comes from your council and decides whether the project is allowed on that land: overlays, zoning, streetscape. A <strong>building permit</strong> comes from a building surveyor and covers whether the construction meets the regulations. Heritage sends you to the first. A verandah sends you to both.</p>\n\n<h2>What we give you for an application</h2>\n\n<p>We supply awnings and do not lodge applications. We do provide what a council, surveyor or Owners Corporation will ask for: product specifications with dimensions and clearances, the Sauleda fabric data sheet, fixing detail drawings for brick, render and timber, and Dooya motor specifications. The AW01 is wind tested by Intertek to EN 13561:2015 at Class 3, and that report is available on request.</p>\n\n<h2>Questions we get asked</h2>\n\n<p><strong>Do I need a permit for a retractable awning in Melbourne?</strong><br>\nIn most cases no. Wall-mounted, retractable, private home, outside a heritage overlay: it is an appendage and no building permit applies.</p>\n\n<p><strong>What if my house is in a heritage overlay?</strong><br>\nYou will need a planning permit. Most are approved. Allow 6 to 10 weeks.</p>\n\n<p><strong>Does ASG handle the permit process?</strong><br>\nNo. We supply the documentation your application needs and you or your builder lodge it.</p>\n\n<p><strong>What about a balcony in an apartment?</strong><br>\nWritten Owners Corporation consent first. Some buildings allow it with conditions, others have a standing no.</p>\n\n<p><strong>What if I skip it in a heritage overlay?</strong><br>\nThe council can order the awning removed at your cost, and unapproved work surfaces during conveyancing when you sell.</p>\n\n<h2>Next</h2>\n\n<p>Once approval is sorted, or if you never needed it, the fitting is the other half of the question. Read <a href=\"/blog/do-you-need-an-installer-for-an-awning\">Do You Need an Installer for an Awning?</a> and the step-by-step <a href=\"/blog/how-to-install-a-retractable-awning-into-solid-brick\">How to Install a Retractable Awning into Solid Brick</a>.</p>\n\n<p>Send us your address and a couple of photos of the wall and we will come back with a model, fabric and projection that suits, plus the documentation pack if you are in an overlay.</p>"
  },
  {
    "_id": "69c23c822ffd464a4a1d6ead",
    "slug": "do-you-need-a-permit-for-a-pergola-in-melbourne",
    "title": "Do You Need a Permit for a Pergola in Melbourne?",
    "excerpt": "In most cases, yes - you need a building permit for a pergola in Melbourne. But there are exemptions for small, freestanding, open-frame structures under 20m². Here's a plain-English guide covering VIC permit rules, the Australian Standards a permit must meet, the permit process, costs, and how ASG's supply-only service fits in.",
    "featured_image": "/uploads/content/project-dandenong-2-after.webp",
    "published_at": "2026-03-24T07:25:54.793Z",
    "tags": [
      "permits",
      "building regulations",
      "melbourne",
      "victoria",
      "australia",
      "pergola planning",
      "outdoor living"
    ],
    "seo_title": "Pergola Permits Melbourne - Do You Need One?",
    "seo_description": "Does your Melbourne pergola need a building permit? VIC exemptions, Australian Standards, the permit process step by step, costs and state-by-state rules.",
    "content": "<p class=\"tldr\"><strong>TL;DR:</strong> In most cases, yes - you need a building permit for a <strong>pergola in Melbourne</strong>. But there are exemptions. A small, freestanding, open-frame pergola under 20m² with no solid roof <em>may</em> be exempt - but add polycarbonate, Colorbond, louvered blades, or any waterproof roofing and it's legally reclassified as a <strong>verandah</strong>, which always requires a permit regardless of size. ASG Shading is supply-only: we supply the pergola and its product specifications, but installation, the structural engineering certification, and the permit process are arranged by you and your licensed builder, surveyor and engineer.</p>\n\n<h2>The Short Answer</h2>\n\n<p>In most cases, <strong>yes - you need a building permit for a pergola in Melbourne</strong>. But there are exemptions for very small, simple structures.</p>\n\n<p>Victoria's building regulations are set by the <strong>Victorian Building Authority (VBA)</strong> under the <em>Building Regulations 2018</em>, Schedule 3. These rules are consistent across <strong>every Melbourne metropolitan council</strong> - from Wyndham to Yarra Ranges.</p>\n\n<h2>When You DON'T Need a Permit</h2>\n\n<p>Your pergola may be exempt from a building permit if it meets <strong>ALL</strong> of these criteria:</p>\n\n<ul>\n<li><strong>Floor area under 20 square metres</strong> - that's roughly 5m × 4m</li>\n<li><strong>No solid roof</strong> - open-frame, shade cloth, open-weave lattice, or wire for climbing plants only</li>\n<li><strong>Maximum height of 3.6 metres</strong> - from ground level to the highest point</li>\n<li><strong>Not more than 2.5m forward of the front wall</strong> of your house (if attached)</li>\n<li><strong>Not located over an easement</strong> - council or water easements are off-limits without written consent</li>\n<li><strong>Not in a heritage overlay or bushfire zone</strong></li>\n<li><strong>Doesn't affect stormwater drainage</strong> on your property or your neighbour's</li>\n<li><strong>Complies with siting regulations</strong> - set back from boundaries as required by your council</li>\n<li><strong>Not made of masonry</strong> (brick or stone)</li>\n<li><strong>Does not affect the structural integrity</strong> of any building it's attached to</li>\n</ul>\n\n<p>That's a fairly restrictive set of conditions. And here's the key point - the exemption only applies to <strong>open-frame pergolas with no solid roof</strong>. The moment you add any form of waterproof roofing, the structure becomes a verandah, which always needs a permit.</p>\n\n<h2>When You DEFINITELY Need a Permit</h2>\n\n<p>You need a building permit if your pergola:</p>\n\n<ul>\n<li><strong>Exceeds 20 square metres</strong> - a typical 5m × 5m pergola is 25m², so many practical projects exceed this</li>\n<li><strong>Has a solid or closable roof</strong> - this includes louvered, retractable, polycarbonate, Colorbond, or any waterproof roofing material</li>\n<li><strong>Is attached to your house</strong> and affects the dwelling's structural integrity</li>\n<li><strong>Is in the front yard</strong> or extends more than 2.5m forward of your front wall</li>\n<li><strong>Is higher than 3.6 metres</strong></li>\n<li><strong>Sits over an easement</strong> or within a heritage, flood, or bushfire overlay zone</li>\n<li><strong>Requires structural changes to your home</strong> - bolt-on connections, removing walls, modifying roof lines</li>\n<li><strong>Affects neighbours' properties</strong> - stormwater runoff, overlooking, or boundary proximity issues</li>\n</ul>\n\n<p>In practice, most pergolas that are large enough to genuinely improve your outdoor living space will need a building permit - and that's completely normal.</p>\n\n<h2>The \"Solid Roof\" Trap - Pergola vs Verandah</h2>\n\n<p>This is the single most important distinction in Victorian building law for outdoor structures, and it catches a lot of homeowners off guard:</p>\n\n<ul>\n<li><strong>Open roof = pergola</strong> - may be exempt from a building permit (if under 20m² and meets all other exempt criteria)</li>\n<li><strong>Solid roof = verandah</strong> - <em>always</em> requires a building permit, <strong>no matter the size</strong></li>\n</ul>\n\n<p>As soon as you add <strong>a single sheet of polycarbonate (Laserlite), Colorbond, or any waterproof material</strong>, the structure is legally reclassified as a verandah. This includes:</p>\n\n<ul>\n<li><strong>Louvered pergolas</strong> like the <a href=\"/products/pergola-175\">ASG Pergola 175</a> or <a href=\"/products/pergola-163\">Pergola 163</a> - the motorised blades seal to form a waterproof roof</li>\n<li><strong>Retractable pergolas</strong> like the <a href=\"/products/pergola-180-retractable\">ASG Pergola 180</a> - the PVC or fabric canopy is considered a solid covering when extended</li>\n<li><strong>Any fixed polycarbonate, glass, or metal roofing</strong></li>\n</ul>\n\n<p><strong>What this means for you:</strong> if you want a weatherproof outdoor area (which most Melbourne homeowners do), you will need a building permit. The vast majority of quality pergola projects require one - and that's a good thing, because it means your structure is properly engineered and safe.</p>\n\n<h2>What About Gazebos, Carports &amp; Decks?</h2>\n\n<p>Pergolas aren't the only outdoor structure with permit rules. Here's how related structures are treated in Victoria:</p>\n\n<h3>Gazebos &amp; Freestanding Structures</h3>\n<p>A small freestanding gazebo may be exempt from a building permit if it's under <strong>20m² in area</strong>, under <strong>3.6m in height</strong>, has no solid roof, and meets the same siting and overlay conditions as pergolas. However, larger gazebos, or those with solid roofing, enclosed sides, or located in overlay zones will need a permit - just like pergolas.</p>\n\n<h3>Carports</h3>\n<p>Carports have a solid roof by definition, so they <strong>almost always require a building permit</strong> in Victoria. They may also need a planning permit depending on size, location, and proximity to boundaries or the street frontage.</p>\n\n<h3>Decks</h3>\n<p>Most raised decking projects require a building permit in Victoria - particularly if the deck is more than 800mm above ground level. If you're combining a deck with a pergola roof, it's best to manage them as a single permit application.</p>\n\n<p><strong>Planning multiple outdoor upgrades?</strong> If your project involves a combination - say a pergola with a deck, or a pergola with <a href=\"/products/glass-walls-screens\">glass walls</a> and <a href=\"/products/led-lighting-heaters\">integrated heating</a> - it's far more efficient for your builder to bundle everything into a single permit application.</p>\n\n<h2>The Permit Process - Step by Step</h2>\n\n<p>Here's what the permit process looks like when your builder or surveyor applies for a building permit:</p>\n\n<ol>\n<li><strong>Site assessment</strong> - your builder or surveyor measures the space, checks for overlays, easements, and any site-specific conditions</li>\n<li><strong>Design drawings</strong> - architectural plans showing the pergola layout, dimensions, post positions, and how it relates to your house and boundaries</li>\n<li><strong>Engineering</strong> - structural calculations for footings, frame, connections, and wind loads - certified to Australian Standards (AS/NZS 1170, AS/NZS 1664, NCC)</li>\n<li><strong>Application</strong> - the full package is submitted to a private registered building surveyor</li>\n<li><strong>Approval</strong> - usually 2 to 4 weeks for a standard residential pergola</li>\n<li><strong>Construction</strong> - once approved, your installer builds the structure. The permit is displayed on site as required by law</li>\n<li><strong>Final inspection</strong> - the building surveyor inspects the completed structure and signs off on compliance</li>\n</ol>\n\n<p>ASG's part in all of this is the supply: we provide the pergola's product specifications and dimensions. The structural engineering and certification for the permit are arranged through your building surveyor or engineer, and your licensed builder handles the site work.</p>\n\n<h2>Australian Standards for Pergolas</h2>\n\n<p>Every pergola that requires a building permit must be engineered to comply with the relevant <strong>Australian Standards</strong>. These are the national benchmarks that ensure your structure is safe, durable, and built to withstand local conditions. Your building surveyor and engineer confirm which apply to your specific structure:</p>\n\n<ul>\n<li><strong>AS/NZS 1170 - Structural Design Actions</strong> - covers wind loads, dead loads, live loads, and other forces the structure must resist. This is critical in Melbourne, where wind conditions can be severe</li>\n<li><strong>AS/NZS 1664 - Aluminium Structures</strong> - the primary standard for our aluminium pergola frames. Covers design, fabrication, and connection requirements for structural aluminium</li>\n<li><strong>AS 4100 - Steel Structures</strong> - applies to any steel components, footing plates, or connections used in the structure</li>\n<li><strong>AS 1720 - Timber Structures</strong> - applies where timber is used (e.g., timber decking attachments or subframes)</li>\n<li><strong>National Construction Code (NCC)</strong> - the overarching code that building surveyors assess against</li>\n</ul>\n\n<p>When your building surveyor reviews the permit application, they check that the engineering documentation demonstrates compliance with these standards. Your surveyor or a structural engineer prepares and certifies that engineering for your specific pergola.</p>\n\n<h2>When You Also Need a Planning Permit</h2>\n\n<p>A <strong>planning permit</strong> is separate from a building permit. It's issued by your local council and covers how the structure fits with your property's zoning and overlays. You may need one if:</p>\n\n<ul>\n<li><strong>Small lot (under 300m²)</strong> - almost any external structure requires a planning permit</li>\n<li><strong>Heritage Overlay (HO)</strong> - common in inner suburbs like Richmond, Carlton, Footscray, and parts of Williamstown. Any structure visible from the street usually needs a permit and possibly a heritage assessment</li>\n<li><strong>Special Building Overlay (SBO)</strong> - flood-prone areas with restrictions on materials and placement</li>\n<li><strong>Bushfire Management Overlay (BMO/BAL)</strong> - extra requirements for fire-rated materials and construction</li>\n<li><strong>Easements</strong> - you cannot build over a council or water easement (where pipes run underground) without \"Consent to Build Over an Easement\" from the relevant authority, such as Melbourne Water</li>\n<li><strong>Front setback areas</strong> - some councils restrict structures within a certain distance of the street</li>\n</ul>\n\n<p><strong>Pro tip:</strong> check your property's overlays for free on <strong>VicPlan</strong> - the Victorian Government's online planning map. Search your address and look for coloured overlays on your lot. Also check your Certificate of Title or Section 32 for any easements in your backyard.</p>\n\n<h2>Building Permit vs Planning Permit - What's the Difference?</h2>\n\n<table>\n<thead>\n<tr><th>Feature</th><th>Building Permit</th><th>Planning Permit</th></tr>\n</thead>\n<tbody>\n<tr><td><strong>Purpose</strong></td><td>Ensures the structure is safe and meets the National Construction Code (NCC)</td><td>Ensures the structure meets council rules about property use, appearance, and zoning</td></tr>\n<tr><td><strong>Issued by</strong></td><td>Registered building surveyor (private or council)</td><td>Your local council planning department</td></tr>\n<tr><td><strong>When required</strong></td><td>Any verandah (solid roof). Open pergolas over 20m² or taller than 3.6m</td><td>Heritage, flood, or bushfire overlays. Small lots. Easements. Front setback areas</td></tr>\n<tr><td><strong>Typical timeline</strong></td><td>2 to 4 weeks (private surveyor)</td><td>6 to 12 weeks (longer if neighbours object)</td></tr>\n</tbody>\n</table>\n\n<p>You might need just one, both, or neither - it depends on the structure, your property, and your council zone.</p>\n\n<h2>Quick Reference: Do I Need a Permit?</h2>\n\n<table>\n<thead>\n<tr><th>Structure Type</th><th>Building Permit?</th><th>Planning Permit?</th></tr>\n</thead>\n<tbody>\n<tr><td>Open pergola under 20m² (all exempt criteria met)</td><td>No</td><td>Only if overlays or small lot</td></tr>\n<tr><td>Open pergola over 20m²</td><td>Yes</td><td>Often yes</td></tr>\n<tr><td>Pergola with solid roof (any size)</td><td>Yes - always (classified as verandah)</td><td>Often yes</td></tr>\n<tr><td>Louvered pergola</td><td>Yes - always</td><td>Often yes</td></tr>\n<tr><td>Retractable pergola</td><td>Yes - always</td><td>Often yes</td></tr>\n<tr><td>Freestanding gazebo under 20m² (open roof)</td><td>No (if all exempt criteria met)</td><td>Only if overlays or small lot</td></tr>\n<tr><td>Carport (solid roof)</td><td>Yes - always</td><td>Often yes</td></tr>\n<tr><td>Raised deck (over 800mm)</td><td>Yes</td><td>Depends on council</td></tr>\n<tr><td>Shade sail under 20m²</td><td>No</td><td>Usually no</td></tr>\n</tbody>\n</table>\n\n<h2>How Much Does a Pergola Permit Cost in Melbourne?</h2>\n\n<p>A pergola building permit in Melbourne, arranged through a private building surveyor, typically costs <strong>$1,500 - $2,500</strong>. That usually covers:</p>\n\n<ul>\n<li><strong>Certified engineering drawings</strong> - wind load, dead load, and structural calculations to AS/NZS 1170 and NCC standards</li>\n<li><strong>Building permit lodgement</strong> - via a private registered building surveyor</li>\n<li><strong>All documentation and coordination</strong> - managing the back-and-forth with the surveyor</li>\n<li><strong>Final inspection</strong> - surveyor sign-off once construction is complete</li>\n</ul>\n\n<p>If a <strong>planning permit</strong> is also required (heritage, overlay, or easement situations), council fees are typically an additional $1,200 - $3,000+ depending on the complexity.</p>\n\n<h2>How Long Does the Permit Process Take?</h2>\n\n<ul>\n<li><strong>Building permit only:</strong> 2 to 4 weeks via a private building surveyor</li>\n<li><strong>Planning permit:</strong> 6 to 12 weeks (sometimes longer if neighbours object or council requests more info)</li>\n<li><strong>Combined:</strong> allow 2 - 3 months total if both are required</li>\n</ul>\n\n<p><strong>Time-saving strategy:</strong> start the permit process early with your builder or surveyor, so that by the time your pergola is manufactured and delivered, the approvals are already sorted.</p>\n\n<h2>Melbourne Council-Specific Notes</h2>\n\n<p>While the VBA building rules are the same statewide, each council handles planning permits and overlays differently. Here are notes from our experience supplying across Melbourne:</p>\n\n<ul>\n<li><strong>Wyndham (Point Cook, Werribee)</strong> - growing suburbs with newer estates. Fewer heritage overlays, but check for easements and developer covenants which can restrict structures</li>\n<li><strong>Greater Dandenong</strong> - mixed zoning. Some flood-prone areas near Dandenong Creek have Special Building Overlays</li>\n<li><strong>Moreland / Merri-bek (Hadfield, Coburg, Brunswick)</strong> - from our experience, council processes here tend to be <strong>stricter and slower</strong> than average. Allow extra time for planning permit applications</li>\n<li><strong>Bayside, Boroondara, Stonnington</strong> - many properties carry Heritage Overlays. Expect a planning permit and possibly a heritage assessment</li>\n<li><strong>Casey, Cardinia, Whittlesea</strong> - outer growth corridors. Generally fewer overlays but may have BMO zones near bushland</li>\n<li><strong>Port Phillip, Yarra</strong> - dense inner-city areas with ResCode setback considerations. Get surveyor advice early</li>\n<li><strong>Mornington Peninsula</strong> - significant vegetation and landscape overlays. Council may require arborist reports if large trees are nearby</li>\n</ul>\n\n<h2>What ASG Products Need a Permit?</h2>\n\n<p>Because all of our premium pergola systems feature a solid or closable roof, they require a building permit in Victoria. Here's a quick overview:</p>\n\n<ul>\n<li><strong><a href=\"/products/pergola-163\">Pergola 163</a></strong> - compact louvered system. Motorised blades seal shut, so it's classified as a verandah. Building permit required.</li>\n<li><strong><a href=\"/products/pergola-175\">Pergola 175</a></strong> - our most popular louvered pergola. Full weather seal with integrated guttering. Building permit required.</li>\n<li><strong><a href=\"/products/pergola-180-retractable\">Pergola 180 Retractable</a></strong> - motorised retractable canopy. Considered a solid covering when extended. Building permit required.</li>\n</ul>\n\n<p>Your building surveyor and engineer handle the structural certification for the permit; we supply the product specifications and dimensions they'll need.</p>\n\n<h2>Pergola Permit Rules Across Australia</h2>\n\n<p>If you're reading from outside Victoria, here's a state-by-state snapshot. Rules change regularly - always confirm with your local council or certifier.</p>\n\n<h3>New South Wales</h3>\n<p>NSW uses the <strong>Exempt and Complying Development</strong> system under the State Environmental Planning Policy. A pergola may be exempt if it's:</p>\n<ul>\n<li>Under 25m² (more generous than VIC)</li>\n<li>No higher than 3m above existing ground level</li>\n<li>Open on all sides (no walls)</li>\n<li>Set back at least 900mm from boundaries</li>\n</ul>\n<p>Solid roofs and enclosed sides push you into <strong>Complying Development</strong> or a full <strong>Development Application (DA)</strong>.</p>\n\n<h3>Queensland</h3>\n<p>QLD councils follow the <strong>Building Act 1975</strong> and local planning schemes. Generally:</p>\n<ul>\n<li>Class 10 structures (carports, pergolas) under 10m² may be exempt</li>\n<li>Larger structures need a building approval from a private certifier</li>\n<li>Brisbane City Council has its own neighbourhood plans - always check your specific suburb</li>\n</ul>\n\n<h3>South Australia</h3>\n<p>SA operates under the <strong>Planning and Design Code</strong> (introduced 2021). Pergolas are often treated as outbuildings:</p>\n<ul>\n<li>Under 15m² with open sides may be exempt in most zones</li>\n<li>Height limit of 3m for exempt structures</li>\n<li>Check the SA PlanningPortal for your specific zone rules</li>\n</ul>\n\n<h3>Western Australia</h3>\n<p>WA uses <strong>Deemed-to-Comply</strong> rules under the Residential Design Codes (R-Codes):</p>\n<ul>\n<li>Unenclosed pergolas under certain sizes may not need approval</li>\n<li>If adding a solid roof, it counts towards site coverage - may trigger a building permit</li>\n<li>Some councils still require approval for structures in setback areas</li>\n</ul>\n\n<h3>Tasmania, ACT &amp; Northern Territory</h3>\n<ul>\n<li><strong>Tasmania:</strong> generally requires a building permit for structures over 9m² or attached to a dwelling</li>\n<li><strong>ACT:</strong> exempt development rules apply for small open structures - check the ACT Planning portal</li>\n<li><strong>Northern Territory:</strong> more relaxed regulations overall, but cyclone-rated engineering is mandatory in many areas</li>\n</ul>\n\n<h2>What Happens If You Build Without a Permit?</h2>\n\n<p>Building without a required permit in Victoria can result in:</p>\n\n<ul>\n<li><strong>Building notices or orders</strong> - council can require you to modify or demolish the structure</li>\n<li><strong>Fines exceeding $90,000</strong> for individuals under the Building Act 1993</li>\n<li><strong>Insurance voidance</strong> - your home and contents insurance may not cover damage involving a non-permitted structure</li>\n<li><strong>Problems when selling</strong> - conveyancers and buyers check for permits during due diligence. A missing permit can delay or kill a property sale</li>\n<li><strong>Forced removal</strong> - in serious cases, council can order the structure to be pulled down entirely at your expense</li>\n</ul>\n\n<p>It's never worth the risk. The permit process for a residential pergola is straightforward - especially when your builder or surveyor manages it for you.</p>\n\n<h2>Why Permits Actually Protect You</h2>\n\n<p>It's easy to think of permits as red tape, but they exist to protect you, your family, your neighbours, and future buyers of your home. A properly permitted pergola means:</p>\n\n<ul>\n<li><strong>It's structurally safe</strong> - engineered to handle Melbourne's wind loads and weather conditions</li>\n<li><strong>It's legally compliant</strong> - no risk of fines, removal orders, or council disputes</li>\n<li><strong>Your insurance is valid</strong> - your policy covers the structure and anything that happens under it</li>\n<li><strong>It adds value when selling</strong> - buyers and conveyancers see a permitted structure as an asset, not a liability</li>\n<li><strong>It's built to last</strong> - compliance with Australian Standards (AS/NZS 1170, NCC) means your pergola is designed for the long term</li>\n</ul>\n\n<p>A permit isn't an obstacle - it's proof that your investment is done properly.</p>\n\n<h2>5 Tips to Make the Permit Process Easy</h2>\n\n<ol>\n<li><strong>Check your overlays first</strong> - search your address on VicPlan (VIC), the NSW Planning Portal, or your state's equivalent. Five minutes of research can save weeks of surprises.</li>\n<li><strong>Check for easements</strong> - review your Certificate of Title or Section 32 for any drainage or services easements. You can't build over these without written consent.</li>\n<li><strong>Use a private building surveyor</strong> - they're typically faster and more responsive than going through council. Expect 2 to 4 weeks instead of 6-8.</li>\n<li><strong>Talk to your neighbours</strong> - if a planning permit is required, neighbours will be notified. A quick heads-up avoids formal objections and delays.</li>\n<li><strong>Work with a builder or surveyor who handles permits daily</strong> - they know exactly what your council expects. ASG supplies the certified engineering and product data they'll need, so your paperwork moves faster.</li>\n</ol>\n\n<h2>Frequently Asked Questions</h2>\n\n<h3>Do I need a building permit for a pergola in Melbourne?</h3>\n<p>In most cases, yes. If your pergola has a solid roof (including louvered or retractable systems), it's classified as a verandah and always needs a building permit. Open-frame pergolas under 20m² and 3.6m high may be exempt, but most practical builds exceed these limits.</p>\n\n<h3>Do I need council approval for a pergola?</h3>\n<p>Council approval (a planning permit) is separate from a building permit and isn't always required. You'll need council approval if your property has a Heritage Overlay, Special Building Overlay, Bushfire Management Overlay, is on a small lot under 300m², or if the structure is near your front boundary. Check VicPlan for your specific property overlays.</p>\n\n<h3>Do I need a permit for a verandah in Victoria?</h3>\n<p>Yes - nearly always. In Victoria, a verandah is any roofed outdoor structure attached to a dwelling. Because it has a solid roof, it requires a building permit regardless of size. This also applies to pergolas with solid, louvered, or retractable roofs.</p>\n\n<h3>Do I need council approval for a gazebo?</h3>\n<p>A small freestanding gazebo under 20m² with no solid roof may be exempt from a building permit. However, if it's larger, has a solid roof, is near a boundary, or is in a heritage or bushfire zone, you'll need approval. The same overlay and siting rules that apply to pergolas also apply to gazebos.</p>\n\n<h3>Do I need an engineer for a pergola?</h3>\n<p>Yes - in almost all cases where a building permit is required, you'll need <strong>structural engineering certification</strong>. This confirms the pergola meets requirements under AS/NZS 1170 (structural design actions), AS/NZS 1664 (aluminium structures), and the National Construction Code. Your building surveyor or a structural engineer provides this certification as part of the permit application.</p>\n\n<h3>Can I build a pergola on my boundary?</h3>\n<p>Generally no - most councils require setbacks from side and rear boundaries. If the structure is within 1 metre of a boundary, you'll likely need both a building permit and neighbour consent. Your building surveyor can confirm the exact setback requirements for your property.</p>\n\n<h3>How close to the front of my house can I build a pergola?</h3>\n<p>In Victoria, a pergola must not extend more than <strong>2.5 metres forward of the front wall</strong> of your house to qualify for an exemption. Freestanding structures in front setback areas almost always need a planning permit from council.</p>\n\n<h3>Does adding glass walls or blinds affect the permit?</h3>\n<p>Yes. Adding <a href=\"/products/glass-walls-screens\">glass walls</a>, <a href=\"/products/blinds-shutters\">zip blinds</a>, or café screens encloses the structure further. While these don't change the verandah classification (the roof already does that), they may affect ResCode calculations for site coverage and permeability - your building surveyor will factor this in.</p>\n\n<h3>What Australian Standards do pergolas need to meet?</h3>\n<p>Permitted pergolas in Australia must comply with <strong>AS/NZS 1170</strong> (structural design actions including wind loads), <strong>AS/NZS 1664</strong> (aluminium structures), <strong>AS 4100</strong> (steel structures) or <strong>AS 1720</strong> (timber structures) as applicable, and the <strong>National Construction Code (NCC)</strong>. Your building surveyor and engineer confirm compliance with the applicable standards for your specific structure.</p>\n\n<h3>Do carports and decks need a permit too?</h3>\n<p>Yes. Carports have a solid roof, so they almost always require a building permit. Raised decks (over 800mm above ground) also need a permit. If you're combining a deck with a pergola, it's best to bundle them into a single permit application - which your builder can arrange.</p>\n\n<h2>Where ASG Fits In (Supply-Only)</h2>\n\n<p>ASG Shading is supply-only. We do not install, we do not carry out site visits or at-home consultations, and we do not manage council or building permits. What we do:</p>\n\n<ul>\n<li><strong>Supply premium made-to-measure pergola systems</strong> - engineered to order and delivered across Melbourne</li>\n<li><strong>Advise remotely</strong> - send us photos and measurements and we'll confirm the right model, size and configuration for your space</li>\n<li><strong>Provide product specifications and dimensions</strong> - the product details your builder, surveyor and engineer will need for the permit</li>\n</ul>\n\n<p>Installation, the structural engineering certification, and the permit process are arranged by you and your licensed builder, surveyor and engineer.</p>\n\n<p><strong>Send us a photo and your measurements</strong> - we'll recommend the right system from our <a href=\"/products\">pergola range</a> and provide the product specifications your surveyor needs. <a href=\"/request-quote\">Get a written quote</a>, no obligation.</p>\n"
  },
  {
    "_id": "69c22679d1799b30320f5b13",
    "slug": "louvered-vs-retractable-pergolas-which-is-right-for-your-home",
    "title": "Louvered vs Retractable Pergolas - Which Is Right for Your Home?",
    "excerpt": "Louvered pergolas seal shut for rain protection and precise light control. Retractable pergolas slide open for full sky views at a lower price. Here's how to choose the right one for your Melbourne home.",
    "featured_image": "/images/pergola-intro-v3.webp",
    "published_at": "2026-03-24T05:51:53.458Z",
    "tags": [
      "pergolas",
      "louvered",
      "retractable",
      "comparison",
      "melbourne",
      "outdoor living"
    ],
    "seo_title": "Louvered vs Retractable Pergolas Compared",
    "seo_description": "Compare louvered and retractable pergola systems - cost, weather protection, lifespan, and which suits Melbourne homes. Free quotes from ASG Shading.",
    "content": "\n<p class=\"tldr\"><strong>TL;DR:</strong> Louvered pergolas have motorised blades that rotate to control light and rain - they're the premium, all-weather option. Retractable pergolas use a fabric or PVC canopy that slides open and closed - lighter, more affordable, and perfect for sun control. Both suit Melbourne's unpredictable climate, but your best pick depends on how you use your outdoor space.</p>\n\n<h2>Quick Answer: Louvered or Retractable?</h2>\n\n<p>If you want <strong>full weather protection</strong> year-round - rain, wind, and harsh UV - go louvered. If you mainly want <strong>flexible shade</strong> with the option to open up to blue sky, go retractable.</p>\n\n<p>Still not sure? Read on. We'll break down exactly how each system works, what they cost, and which one makes sense for Melbourne homes.</p>\n\n<h2>What Is a Louvered Pergola?</h2>\n\n<p>A louvered pergola (sometimes called an opening roof pergola) has a solid aluminium frame with motorised blades - or louvres - built into the roof. These blades rotate up to 180°, letting you control exactly how much sunlight, airflow, and rain gets through.</p>\n\n<p><strong>When the blades close flat,</strong> they form a fully sealed, waterproof roof. Rain channels through a concealed gutter system and down the posts. When they're open, you get full ventilation and sky views.</p>\n\n<h3>Key Features of Louvered Pergolas</h3>\n<ul>\n<li><strong>Motorised blade rotation</strong> - adjust from fully open to fully sealed with a remote or app</li>\n<li><strong>Rain sensor technology</strong> - blades auto-close when it starts raining (you'll never get caught out)</li>\n<li><strong>Integrated LED lighting</strong> - built into the blade edges for ambient evening use</li>\n<li><strong>Sealed roof when closed</strong> - the blades close flat to form a solid, weatherproof roof</li>\n<li><strong>Powder-coated aluminium</strong> - zero rust, minimal maintenance, 15+ year lifespan</li>\n</ul>\n\n<p>Louvered pergolas are the go-to for homeowners who want a genuine outdoor room - one that works 365 days a year, no matter what Melbourne's weather throws at it.</p>\n\n<h2>What Is a Retractable Pergola?</h2>\n\n<p>A retractable pergola uses a motorised fabric or PVC canopy mounted on an aluminium frame. The canopy slides along tracks - fully extend it for shade, fully retract it to open up to the sky. Think of it like a giant, premium blind for your outdoor area.</p>\n\n<h3>Key Features of Retractable Pergolas</h3>\n<ul>\n<li><strong>Motorised canopy</strong> - extend or retract with a remote, wall switch, or app</li>\n<li><strong>UV-rated fabric</strong> - blocks up to 99% of harmful UV rays when extended</li>\n<li><strong>Full sky access</strong> - when retracted, the canopy bundles neatly to one side - no obstruction</li>\n<li><strong>Lighter feel</strong> - visually less imposing than a solid-roof system, great for smaller spaces</li>\n<li><strong>Simpler to fit</strong> - fewer components than a louvered roof, so your installer fits it faster</li>\n</ul>\n\n<p>Retractable pergolas are ideal for spaces where you want the <strong>option</strong> of shade without permanently blocking the sky - entertaining areas, pool surrounds, and cafe frontages.</p>\n\n<h2>Louvered vs Retractable: Side-by-Side Comparison</h2>\n\n<table>\n<thead>\n<tr><th>Feature</th><th>Louvered Pergola</th><th>Retractable Pergola</th></tr>\n</thead>\n<tbody>\n<tr><td><strong>Rain protection</strong></td><td>Fully waterproof when closed</td><td>Water-resistant (not sealed)</td></tr>\n<tr><td><strong>Wind</strong></td><td>Solid roof when closed</td><td>Retract in high winds</td></tr>\n<tr><td><strong>Light control</strong></td><td>Adjustable - 0% to 100%</td><td>On or off (extended or retracted)</td></tr>\n<tr><td><strong>Open sky view</strong></td><td>Partial (blades visible when open)</td><td>Full (canopy retracts completely)</td></tr>\n<tr><td><strong>Maintenance</strong></td><td>Minimal - hose down yearly</td><td>Fabric may need replacing (8-12 years)</td></tr>\n<tr><td><strong>Lifespan</strong></td><td>15-25+ years</td><td>10-15 years (frame), 8-12 years (fabric)</td></tr>\n<tr><td><strong>Price</strong></td><td>Supply-only, quoted to your size</td><td>Supply-only, quoted to your size</td></tr>\n<tr><td><strong>Fitting time (by your installer)</strong></td><td>2 to 3 days</td><td>1 to 2 days</td></tr>\n<tr><td><strong>Best for</strong></td><td>Outdoor rooms, year-round use</td><td>Entertaining, flexible shade</td></tr>\n</tbody>\n</table>\n\n<h2>When to Choose a Louvered Pergola</h2>\n\n<p>Go louvered if any of these sound like you:</p>\n\n<ul>\n<li><strong>You want an all-weather outdoor room.</strong> Melbourne can go from 35°C sunshine to sideways rain in the same afternoon. Louvered pergolas handle both without you lifting a finger (thanks to rain sensors).</li>\n<li><strong>You entertain regularly.</strong> Never cancel a BBQ because of weather again. Guests stay dry, warm (add <a href=\"/products/led-lighting-heaters\">infrared heaters</a>), and comfortable year-round.</li>\n<li><strong>You're adding long-term value to your home.</strong> A louvered pergola is a permanent structure that adds real resale value - buyers love a finished outdoor room.</li>\n<li><strong>You want precise light control.</strong> Rotate the blades to track the sun throughout the day. Morning coffee with full sun, afternoon shade while you work, evening ambiance with LEDs.</li>\n<li><strong>You live in an exposed spot.</strong> Bayside suburbs, elevated blocks, or anywhere that cops a westerly - a solid louvered roof that seals shut suits an exposed area.</li>\n</ul>\n\n<h2>When to Choose a Retractable Pergola</h2>\n\n<p>Go retractable if this sounds more like your situation:</p>\n\n<ul>\n<li><strong>You want sun control, not rain protection.</strong> If your main goal is blocking UV on hot days but you don't need to sit outside during rain, retractable is the smarter (and cheaper) pick.</li>\n<li><strong>You love open sky.</strong> When retracted, there's nothing above you. Louvered systems always have visible blades - retractable gives you a completely unobstructed view.</li>\n<li><strong>Your space is smaller or you want a lighter look.</strong> Retractable pergolas feel less \"structural\" - great for courtyards, balconies, and compact entertaining areas.</li>\n<li><strong>You're fitting out a commercial space.</strong> Cafes, restaurants, and bars love retractable systems - they're fast to install and give customers the choice of sun or shade.</li>\n<li><strong>Budget matters.</strong> Retractable is the more affordable entry point for a motorised, premium shade system.</li>\n</ul>\n\n<h2>Melbourne Weather: Why It Matters</h2>\n\n<p>Melbourne is famously unpredictable. The Bureau of Meteorology data shows the city averages <strong>147 rainy days per year</strong> - that's 40% of the year where an unprotected outdoor area is unusable.</p>\n\n<p>Here's how each system handles Melbourne's seasonal challenges:</p>\n\n<h3>Summer (December - February)</h3>\n<p><strong>Louvered:</strong> Angle blades to block direct sun while allowing airflow. Close fully during afternoon storms. Add <a href=\"/products/led-lighting-heaters\">LED strip lighting</a> for late summer evenings.</p>\n<p><strong>Retractable:</strong> Extend canopy for UV protection. Retract in the evening for stargazing. Fabric blocks up to 99% UV.</p>\n\n<h3>Winter (June - August)</h3>\n<p><strong>Louvered:</strong> Close blades for rain protection. Open on clear winter days to let warmth in. Pair with infrared heaters for year-round outdoor dining.</p>\n<p><strong>Retractable:</strong> Generally retracted - fabric isn't designed for heavy rain or pooling water. Use on dry winter days for windbreak effect.</p>\n\n<h3>The Shoulder Seasons (Autumn &amp; Spring)</h3>\n<p>This is where Melbourne is most unpredictable - and where louvered systems really shine. Rain sensors mean you never have to think about it. Retractable works great on dry days but needs manual management when weather shifts.</p>\n\n<h2>What About a Flat Blade Pergola?</h2>\n\n<p>Worth mentioning: there's a third option. <strong>Flat blade pergolas</strong> have fixed aluminium blades that don't rotate. They provide permanent partial shade and a clean, architectural look - but you can't close them for rain protection or open them for full sun.</p>\n\n<p>They're the most affordable option and look stunning, but they're a compromise between louvered and retractable. <a href=\"/products/compare\">Compare all three systems here</a>.</p>\n\n<h2>Cost Breakdown: What to Budget</h2>\n\n<p>Pergola pricing depends on size, options, and configuration. As a supply-only guide for a typical 4m × 3m pergola:</p>\n\n<table>\n<thead>\n<tr><th>Cost Component</th><th>Louvered</th><th>Retractable</th></tr>\n</thead>\n<tbody>\n<tr><td>Base system</td><td>Quoted to your size</td><td>Quoted to your size</td></tr>\n<tr><td>LED lighting upgrade</td><td>Built-in (most models)</td><td>Optional add-on</td></tr>\n<tr><td>Rain sensor</td><td>Included</td><td>N/A</td></tr>\n<tr><td>Side screens / blinds</td><td>Optional add-on</td><td>Optional add-on</td></tr>\n<tr><td>Heaters</td><td>Optional add-on</td><td>Optional add-on</td></tr>\n</tbody>\n</table>\n\n<p>Both are supply-only and quoted to your exact size and configuration. Send us a photo and your measurements for a detailed written quote. <a href=\"/request-quote\">Request your free quote here</a>.</p>\n\n<h2>Ordering: What to Expect</h2>\n\n<p>ASG is supply-only, so the process is simple and there is no site visit:</p>\n\n<ol>\n<li><strong>Send photos and measurements</strong> - a couple of photos of your space and the available dimensions</li>\n<li><strong>Custom quote</strong> - a detailed written quote, usually within 48 hours, no surprises</li>\n<li><strong>Permit check</strong> - we'll flag whether a building permit is likely; you and your builder or surveyor arrange it</li>\n<li><strong>Manufacturing</strong> - 3 to 6 weeks depending on the system</li>\n<li><strong>Delivery</strong> - we deliver across Melbourne, and your licensed installer fits it</li>\n</ol>\n\n<h2>FAQ</h2>\n\n<h3>Are louvered pergolas worth the extra cost over retractable?</h3>\n<p>If you plan to use your outdoor area year-round - including during rain - yes. The rain sensor and full waterproofing (when the blades close flat) make louvered pergolas a genuine all-weather solution. If you mainly need summer shade, a retractable system delivers great value at a lower price point.</p>\n\n<h3>Can I add side screens to either type?</h3>\n<p>Yes. Both louvered and retractable pergolas can be fitted with <a href=\"/products/blinds-shutters\">zip-track blinds, glass walls, or mesh screens</a> for wind protection and privacy. These are available as add-ons during or after installation.</p>\n\n<h3>Do I need a building permit for a pergola in Melbourne?</h3>\n<p>In many cases, no. Under Victorian building regulations, pergolas under a certain size threshold on residential properties are often exempt from permits. However, it depends on your lot size, setbacks, and council overlays. Your building surveyor confirms this - see our guide on pergola permits in Melbourne, and we can supply the product specifications your surveyor needs.</p>\n\n<h3>How long do pergola systems last?</h3>\n<p>Louvered pergolas are built from powder-coated aluminium and last 15-25+ years with minimal maintenance. Retractable systems have a similar frame lifespan, but the fabric canopy typically needs replacing every 8-12 years depending on UV exposure and usage.</p>\n\n<h3>Can I fit a pergola myself?</h3>\n<p>Pergolas are supply-only, so fitting is arranged by you. Both systems require precise structural fixing, electrical connections (for motors, lighting, and sensors), and waterproofing, so we strongly recommend a licensed builder or installer rather than a DIY fit - incorrect installation can void warranties and create safety issues.</p>\n\n<p><strong>Ready to see which pergola suits your space?</strong> <a href=\"/request-quote\">Get a free quote</a> - send us a photo and your measurements and we'll recommend the right system for your home.</p>\n"
  }
];

export const fallbackSettings = {
  "home_rangemap_hotspots": [
    {
      "label": "B06 Premium Open-Arm Awning",
      "target": "/products/b06-premium-open-arm-awning",
      "points": [
        [
          41.2,
          19.7
        ],
        [
          45.5,
          17
        ],
        [
          50.4,
          13.1
        ],
        [
          50.3,
          11.8
        ],
        [
          38.3,
          6.5
        ],
        [
          29.4,
          12.6
        ],
        [
          29.7,
          13.6
        ]
      ],
      "labelPoints": [
        [
          26.7,
          4
        ],
        [
          26.7,
          8.5
        ],
        [
          39.5,
          8.9
        ],
        [
          39.5,
          3.9
        ],
        [
          39.5,
          8.9
        ],
        [
          39.5,
          3.9
        ]
      ]
    },
    {
      "label": "AW01 Full Cassette Awning",
      "target": "/products/aw01-full-box-awning",
      "points": [
        [
          67.6,
          32.1
        ],
        [
          67.6,
          31
        ],
        [
          72.3,
          24.6
        ],
        [
          59.3,
          18.2
        ],
        [
          53.7,
          24.5
        ],
        [
          54,
          24.8
        ],
        [
          53.7,
          24.5
        ]
      ],
      "labelPoints": [
        [
          62.7,
          13.6
        ],
        [
          62.6,
          18.6
        ],
        [
          74,
          18.8
        ],
        [
          74,
          13.4
        ]
      ]
    },
    {
      "label": "A09 Long-Projection Awning",
      "target": "/products/a09-long-projection-wind-resistant-awning",
      "points": [
        [
          83.8,
          36.5
        ],
        [
          83.9,
          35.1
        ],
        [
          86.7,
          31.5
        ],
        [
          75.4,
          25.7
        ],
        [
          72.3,
          29
        ],
        [
          72.3,
          30.2
        ]
      ],
      "labelPoints": [
        [
          79.1,
          24.7
        ],
        [
          79.1,
          18.3
        ],
        [
          90.2,
          18.2
        ],
        [
          90.4,
          25.1
        ],
        [
          90.4,
          25.1
        ]
      ]
    },
    {
      "label": "K3 Heritage Mediterranean",
      "target": "/products/k3-heritage-mediterranean-awning",
      "points": [
        [
          89.6,
          40.5
        ],
        [
          89.7,
          38.4
        ],
        [
          92.2,
          35.1
        ],
        [
          99.4,
          39
        ],
        [
          97.3,
          42.4
        ],
        [
          97.3,
          45
        ]
      ],
      "labelPoints": [
        [
          98.4,
          32.3
        ],
        [
          98.3,
          27.1
        ],
        [
          87.5,
          27.1
        ],
        [
          87.5,
          32.3
        ]
      ]
    },
    {
      "label": "B05 Traditional Scalloped",
      "target": "/products/b05-traditional-scalloped-awning",
      "points": [
        [
          18.7,
          52.5
        ],
        [
          16.4,
          56.5
        ],
        [
          16.2,
          58.2
        ],
        [
          9,
          51.7
        ],
        [
          8.9,
          49.9
        ],
        [
          11.3,
          46.1
        ],
        [
          11.3,
          46.1
        ]
      ],
      "labelPoints": [
        [
          7.3,
          49.3
        ],
        [
          7.5,
          42.9
        ],
        [
          0,
          42.9
        ],
        [
          0,
          49.3
        ]
      ]
    },
    {
      "label": "Pergola 180 Retractable",
      "target": "#pergolas-range",
      "points": [
        [
          15.5,
          22.2
        ],
        [
          4.4,
          28.8
        ],
        [
          5.2,
          42.3
        ],
        [
          17.5,
          50.5
        ],
        [
          28.6,
          43.1
        ],
        [
          28.6,
          43.1
        ],
        [
          28.7,
          31.6
        ]
      ],
      "labelPoints": [
        [
          6.7,
          18.2
        ],
        [
          6.7,
          23.4
        ],
        [
          16.5,
          23.4
        ],
        [
          16.6,
          18
        ],
        [
          16.6,
          18
        ],
        [
          16.5,
          23.4
        ],
        [
          6.7,
          23.4
        ]
      ]
    },
    {
      "label": "Pergola 175",
      "target": "#pergolas-range",
      "points": [
        [
          38.9,
          31.3
        ],
        [
          28.9,
          37.5
        ],
        [
          29.3,
          52.8
        ],
        [
          41.2,
          62.3
        ],
        [
          50.4,
          53.9
        ],
        [
          50.6,
          38.9
        ],
        [
          50.6,
          38.9
        ]
      ],
      "labelPoints": [
        [
          36.5,
          31.6
        ],
        [
          36.6,
          26.5
        ],
        [
          42.8,
          26.4
        ],
        [
          42.8,
          31.8
        ],
        [
          42.7,
          31.6
        ],
        [
          36.5,
          31.6
        ],
        [
          42.7,
          31.6
        ]
      ]
    },
    {
      "label": "Pergola 220",
      "target": "#pergolas-range",
      "points": [
        [
          68.2,
          42
        ],
        [
          56.6,
          51.7
        ],
        [
          56.5,
          70.4
        ],
        [
          78.5,
          86.8
        ],
        [
          90.5,
          72.9
        ],
        [
          91,
          56.3
        ]
      ],
      "labelPoints": [
        [
          84.6,
          46.4
        ],
        [
          84.6,
          51.2
        ],
        [
          93.8,
          51.5
        ],
        [
          93.8,
          46.6
        ]
      ]
    },
    {
      "label": "Pergola 163",
      "target": "#pergolas-range",
      "points": [
        [
          21.6,
          56.4
        ],
        [
          13.5,
          62.8
        ],
        [
          14,
          77.4
        ],
        [
          21.3,
          85.4
        ],
        [
          29.2,
          78.9
        ],
        [
          29,
          63.1
        ]
      ],
      "labelPoints": [
        [
          9.4,
          76.3
        ],
        [
          9.3,
          71
        ],
        [
          2.4,
          71.2
        ],
        [
          2.4,
          76.2
        ]
      ]
    },
    {
      "label": "Model 100 Zip Blind",
      "target": "#zip-blinds",
      "points": [
        [
          46.8,
          70.6
        ],
        [
          39.6,
          77.1
        ],
        [
          31.6,
          69.5
        ],
        [
          31.5,
          84.7
        ],
        [
          39.6,
          93
        ],
        [
          47,
          84.9
        ]
      ],
      "labelPoints": [
        [
          48.8,
          82.1
        ],
        [
          48.8,
          87.1
        ],
        [
          56.6,
          87.1
        ],
        [
          56.6,
          82.2
        ],
        [
          56.6,
          82.2
        ]
      ]
    }
  ],
  "home_show_range_map": false,
  "popup_eyebrow": "First 20 Sales!",
  "popup_subtext": "Get notified of arrival and recieve upto $200 OFF!",
  "popup_decline": "No Thanks",
  "featured_projects": [
    {
      "title": "Dandenong Residence",
      "location": "Dandenong, VIC",
      "caption": "Louvered Pergola - 8m x 4.2m span, integrated LED lighting, automated rain sensor",
      "images": [
        {
          "url": "/uploads/content/project-dandenong-1-before.webp",
          "focus": 30
        },
        {
          "url": "/uploads/content/project-dandenong-2-after.webp",
          "focus": 30
        }
      ],
      "video_mp4": "",
      "video_webm": "",
      "video_poster": ""
    },
    {
      "title": "AW01 Full Cassette Awning Install",
      "location": "Rowville, VIC",
      "caption": "AW01 Full Cassette Awning - fully enclosed cassette, motorised, Spanish Sauleda fabric",
      "images": [
        {
          "url": "/uploads/content/project-aw01-2.webp",
          "focus": 15
        },
        {
          "url": "/uploads/content/project-aw01-3.webp",
          "focus": 15
        },
        {
          "url": "/uploads/content/project-aw01-1-extended.webp",
          "focus": 30
        }
      ],
      "video_mp4": "",
      "video_webm": "",
      "video_poster": ""
    }
  ],
  "popup_title": "Up To $200",
  "popup_button": "Sign Up Now",
  "projects": [
    {
      "id": "backyard-makeover-b06",
      "title": "Backyard makeover",
      "location": "",
      "product": "b06-premium-open-arm-awning",
      "colour": "",
      "size": "",
      "caption": "Two tired old awnings replaced with B06s, with LED lighting built into the arms - over the spa and along the side of the house. The before photos show what was there.",
      "featured": false,
      "images": [
        {
          "url": "/uploads/content/project-b06-backyard-after-1.webp",
          "focus": 30,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-backyard-after-2.webp",
          "focus": 45,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-backyard-before-1.webp",
          "focus": 40,
          "label": "Before"
        },
        {
          "url": "/uploads/content/project-b06-backyard-after-3.webp",
          "focus": 35,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-backyard-before-2.webp",
          "focus": 35,
          "label": "Before"
        },
        {
          "url": "/uploads/content/project-b06-backyard-after-4.webp",
          "focus": 30,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-backyard-after-5.webp",
          "focus": 30,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-backyard-after-6.webp",
          "focus": 30,
          "label": ""
        }
      ],
      "videos": [
        {
          "mp4": "/uploads/content/b06-install-backyard.mp4",
          "webm": "",
          "poster": "/uploads/products/b06-install-backyard-poster.webp"
        }
      ]
    },
    {
      "id": "aw01-rowville",
      "title": "AW01 Full Cassette Awning Install",
      "location": "Rowville, VIC",
      "product": "aw01-full-box-awning",
      "colour": "",
      "size": "",
      "caption": "AW01 Full Cassette Awning - fully enclosed cassette, motorised, Spanish Sauleda fabric",
      "featured": true,
      "images": [
        {
          "url": "/uploads/content/project-aw01-2.webp",
          "focus": 15
        },
        {
          "url": "/uploads/content/project-aw01-3.webp",
          "focus": 15
        },
        {
          "url": "/uploads/content/project-aw01-1-extended.webp",
          "focus": 30
        }
      ],
      "videos": []
    },
    {
      "id": "b06-golden-yellow-4m",
      "title": "Golden Yellow B06",
      "location": "",
      "product": "b06-premium-open-arm-awning",
      "colour": "Golden Yellow",
      "size": "4 m wide",
      "caption": "A 4 m B06 in Golden Yellow, run out and tested in our workshop before delivery, with the LED arms on.",
      "featured": false,
      "images": [
        {
          "url": "/uploads/content/project-b06-golden-yellow-1.webp",
          "focus": 35,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-golden-yellow-2.webp",
          "focus": 40,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-golden-yellow-3.webp",
          "focus": 45,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-golden-yellow-4.webp",
          "focus": 40,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-golden-yellow-5.webp",
          "focus": 40,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-golden-yellow-6.webp",
          "focus": 35,
          "label": ""
        }
      ],
      "videos": [
        {
          "mp4": "/uploads/content/b06-install-golden-yellow.mp4",
          "webm": "",
          "poster": "/uploads/products/b06-install-golden-yellow-poster.webp"
        }
      ]
    },
    {
      "id": "b06-mid-grey-pair",
      "title": "Mid Grey B06 pair",
      "location": "",
      "product": "b06-premium-open-arm-awning",
      "colour": "Mid Grey",
      "size": "3 m x 2.5 m, two awnings",
      "caption": "Two matching 3 m x 2.5 m B06 awnings in Mid Grey, tested in our workshop before delivery - LED arms on.",
      "featured": false,
      "images": [
        {
          "url": "/uploads/content/project-b06-mid-grey-1.webp",
          "focus": 40,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-mid-grey-2.webp",
          "focus": 40,
          "label": ""
        },
        {
          "url": "/uploads/content/project-b06-mid-grey-3.webp",
          "focus": 35,
          "label": ""
        }
      ],
      "videos": [
        {
          "mp4": "/uploads/content/b06-install-mid-grey.mp4",
          "webm": "",
          "poster": "/uploads/products/b06-install-mid-grey-poster.webp"
        }
      ]
    },
    {
      "id": "dandenong-pergola",
      "title": "Dandenong Residence",
      "location": "Dandenong, VIC",
      "product": "",
      "colour": "",
      "size": "",
      "caption": "Louvered Pergola - 8m x 4.2m span, integrated LED lighting, automated rain sensor",
      "featured": true,
      "images": [
        {
          "url": "/uploads/content/project-dandenong-1-before.webp",
          "focus": 30
        },
        {
          "url": "/uploads/content/project-dandenong-2-after.webp",
          "focus": 30
        }
      ],
      "videos": []
    }
  ]
};

export const startingAwningPrice = 550;
export const colourChartAvailable = false;
